import { aggregateBy, groupBy } from "@progress/kendo-data-query";
import { CustomNumberPipe } from "src/app/pipe/customNumber.pipe";
import { v4 as uuidv4 } from 'uuid';
import moment from "moment";
import { RxCluDocEnteteDocumentType } from "../@schemas/clu_docentete.schema";
import { RxCluDocLigneDocumentType } from "../@schemas/clu_docligne.schema";
import { RxCluDocReglementDocumentType } from "../@schemas/clu_docreglement.schema";
import { RxFCompteTDocumentType } from "../@schemas/f_comptet.schema";
import { RxFTaxeDocumentType } from "../@schemas/f_taxe.schema";
import { RxCluDocLigneDocument, RxFArticleDocument, RxFTarifQteDocument } from "../@services/m-remdocs-core-rxdb";
import { CluArtFamComptaItem, CluBilanTaxeItem, CluCarteCadeauxItemPickedResult, CluDefaultRemisesResult, CluDiscountResult, CluLotSeriePickedItemResult, CluLoyaltyCardRecompenseParams, CluNomenclatureItem } from "../m-remdocs.model";
import { CluDocContextItem } from "./cludoccontext.model";
import { RxCluDocEcheanceDocumentType } from "../@schemas/clu_docecheance.schema";

export class CluDocItem {
    ENTETE : RxCluDocEnteteDocumentType; 
    LIGNES : RxCluDocLigneDocumentType[];
    REGLEMENTS : RxCluDocReglementDocumentType[];
    ECHEANCES : RxCluDocEcheanceDocumentType[];
    
    private LIGNEREF_VALFRAIS : RxCluDocLigneDocumentType | undefined;

    private LAST_INSERTED_LIGNE : RxCluDocLigneDocumentType | undefined;
    
    UPDATE_TIERS(TIERS : RxFCompteTDocumentType){
        this.ENTETE.DO_TIERS = TIERS.CT_NUM;
        this.ENTETE.CT_INTITULE = TIERS.CT_INTITULE;
        this.ENTETE.DO_DEVISE = 0;
        this.ENTETE.DO_DEVISELIB = '';
        this.ENTETE.DO_COURS = 0;
        this.ENTETE.DO_DEVISE_INV = 0;
        this.ENTETE.DO_DEVISE_FORMAT = '';
        this.ENTETE.DO_COORD04 = '';
        if(TIERS.N_DEVISE && TIERS.N_DEVISE > 0) { 
            this.ENTETE.DO_DEVISE = TIERS.N_DEVISE;
            this.ENTETE.DO_DEVISELIB = TIERS.N_DEVISELIB;
            this.ENTETE.DO_COURS = TIERS.N_DEVISE_COURS;
            this.ENTETE.DO_DEVISE_FORMAT = TIERS.N_DEVISE_FORMAT;
        }
        this.ENTETE.CT_TAUX01 = TIERS.CT_TAUX01;
    }
    
    ADD_LIGNE(LIGNE : RxCluDocLigneDocumentType) : RxCluDocLigneDocumentType {
        if(!LIGNE.DL_GIFTCARD && LIGNE.DL_LCREC != 1 && LIGNE.LS_NOSERIE == '' && this.LAST_INSERTED_LIGNE && this.LAST_INSERTED_LIGNE.DL_VALORISE == 1 && this.LAST_INSERTED_LIGNE.AR_REF == LIGNE.AR_REF && this.LAST_INSERTED_LIGNE.DE_NO == LIGNE.DE_NO && 
            this.LAST_INSERTED_LIGNE.DE_NO == LIGNE.DE_NO && this.LAST_INSERTED_LIGNE.EU_ENUMERE == LIGNE.EU_ENUMERE && this.LAST_INSERTED_LIGNE.DL_PRIXUNITAIRE == LIGNE.DL_PRIXUNITAIRE && this.LAST_INSERTED_LIGNE.DL_REMISE_LIB == LIGNE.DL_REMISE_LIB && 
            this.LAST_INSERTED_LIGNE.AG_NO1 == LIGNE.AG_NO1 && this.LAST_INSERTED_LIGNE.AG_NO2 == LIGNE.AG_NO2 && LIGNE.EU_QTE == LIGNE.DL_QTE){
            let M_INDEX = this.LIGNES.findIndex(m => m.MD_CBMARQ == this.LAST_INSERTED_LIGNE?.MD_CBMARQ);
            if(M_INDEX > -1) { 
                this.LIGNES[M_INDEX].EU_QTE! += LIGNE.EU_QTE!;
                this.LIGNES[M_INDEX].DL_QTE += LIGNE.DL_QTE;
                this.LIGNES[M_INDEX].DL_POIDSNET! += LIGNE.DL_POIDSNET || 0;
                this.LIGNES[M_INDEX].DL_POIDSBRUT! += LIGNE.DL_POIDSBRUT || 0;
                this.LIGNES[M_INDEX].DL_MONTANTHT += LIGNE.DL_MONTANTHT;
                this.LIGNES[M_INDEX].DL_MONTANTTTC += LIGNE.DL_MONTANTTTC;
                this.LAST_INSERTED_LIGNE = this.LIGNES[M_INDEX];
            }
        }
        else {
            this.LIGNES.push(LIGNE);
            this.LAST_INSERTED_LIGNE = LIGNE;
        }
        this.DO_RECALCUL_ENTETE();
        return this.LAST_INSERTED_LIGNE;
    }

    DELETE_LIGNE(MD_CBMARQ : number){
        if(this.LAST_INSERTED_LIGNE && this.LAST_INSERTED_LIGNE.MD_CBMARQ == MD_CBMARQ) { this.LAST_INSERTED_LIGNE = undefined; }
        let M_INDEX = this.LIGNES.findIndex(a=> a.MD_CBMARQ == MD_CBMARQ);
        if(M_INDEX > - 1){
            let M = this.LIGNES[M_INDEX];
            if(M.EST_SOUSTOTAL) { this.LIGNES.forEach(l=> { if(l.DL_NOSOUSTOTAL == M.DL_NO) { l.DL_NOSOUSTOTAL = 0; } }) }
            this.LIGNES.splice(M_INDEX, 1);
        }
        this.DO_RECALCUL_SOUS_TOTAUX();
        this.DO_RECALCUL_ENTETE();
    }

    DELETE_LIGNES(MD_CBMARQ_LIST : number[]){
        MD_CBMARQ_LIST.forEach(MD_CBMARQ => this.DELETE_LIGNE(MD_CBMARQ));
    }

    ADD_SOUSTOTAL(ST_INDEX : number = -1) : number {
        if (this.LIGNES.length == 0) return -1;
        this.LAST_INSERTED_LIGNE = undefined;
        let _subTotalItem : RxCluDocLigneDocumentType = {
            PK_ID : uuidv4(), 
            MD_SITEGID : this.ENTETE.MD_SITEGID,
            MD_SITE : this.ENTETE.MD_SITE,
            USER_ID : this.ENTETE.USER_ID,
            MD_DATE_CREATION : moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
            MD_CBMARQ : this.LIGNES.length == 0 ? 1 : Math.max(...this.LIGNES.map(x=> x.MD_CBMARQ)) + 1,
            DL_NO : 0,
            DO_PIECE : this.ENTETE.DO_PIECE,
            DO_PIECE_INTERNAL : this.ENTETE.DO_PIECE_INTERNAL,
            DL_LIGNE : this.LIGNES.length == 0 ? 1000 : Math.max(...this.LIGNES.map(x=> x.DL_LIGNE)) + 1000,
            AR_REF : '',
            FA_CODEFAMILLE : '',
            DL_DESIGN : 'Sous-Total',
            DL_QTE : 0, 
            DL_POIDSNET : 0, 
            DL_POIDSBRUT : 0, 
            DL_PRIXUNITAIRE : 0, 
            DL_PRIXUNITAIRE_NET : 0, 
            DL_REMISE01REM_VALEUR : 0,
            DL_REMISE01REM_TYPE : 0,
            DL_TAXE1 : 0, 
            DL_CODETAXE1 : '',
            DL_TYPETAUX1 : 0,
            DL_TYPETAXE1 : 0, 
            EU_QTE : 0, 
            EU_ENUMERE : '', 
            DL_TTC : 0, 
            DL_PUTTC : 0, 
            DL_PUTTC_NET : 0, 
            DL_MONTANTHT : 0, 
            DL_MONTANTTTC : 0, 
            DL_VALORISE : 0, 
            DL_NOSOUSTOTAL : 0,
            EST_SOUSTOTAL : true, 
            NBLIGNES_SOUSTOTAL : 0
        };
        if(ST_INDEX < 0) { this.LIGNES.push(_subTotalItem); }
        else { this.LIGNES.splice(ST_INDEX, 0, _subTotalItem); }
        this.DO_RECALCUL_SOUS_TOTAUX();
        return _subTotalItem.MD_CBMARQ;
    }

    ADD_LIGNETEXTE(TEXT_INPUT : string) : number {
        if (this.LIGNES.length == 0) return -1;
        this.LAST_INSERTED_LIGNE = undefined;
        let _textLigneItem : RxCluDocLigneDocumentType = {
            PK_ID : uuidv4(), 
            MD_SITEGID : this.ENTETE.MD_SITEGID,
            MD_SITE : this.ENTETE.MD_SITE,
            USER_ID : this.ENTETE.USER_ID,
            MD_DATE_CREATION : moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
            MD_CBMARQ : this.LIGNES.length == 0 ? 1 : Math.max(...this.LIGNES.map(x=> x.MD_CBMARQ)) + 1,
            DL_NO : 0,
            DO_PIECE : this.ENTETE.DO_PIECE,
            DO_PIECE_INTERNAL : this.ENTETE.DO_PIECE_INTERNAL,
            DL_LIGNE : this.LIGNES.length == 0 ? 1000 : Math.max(...this.LIGNES.map(x=> x.DL_LIGNE)) + 1000,
            AR_REF : '',
            FA_CODEFAMILLE : '',
            DL_DESIGN : TEXT_INPUT,
            DL_QTE : 0, 
            DL_POIDSNET : 0, 
            DL_POIDSBRUT : 0, 
            DL_PRIXUNITAIRE : 0, 
            DL_PRIXUNITAIRE_NET : 0, 
            DL_REMISE01REM_VALEUR : 0,
            DL_REMISE01REM_TYPE : 0,
            DL_TAXE1 : 0, 
            DL_CODETAXE1 : '',
            DL_TYPETAUX1 : 0,
            DL_TYPETAXE1 : 0, 
            EU_QTE : 0, 
            EU_ENUMERE : '', 
            DL_TTC : 0, 
            DL_PUTTC : 0, 
            DL_PUTTC_NET : 0, 
            DL_MONTANTHT : 0, 
            DL_MONTANTTTC : 0, 
            DL_VALORISE : 0, 
            DL_NOSOUSTOTAL : 0,
            EST_SOUSTOTAL : false, 
            NBLIGNES_SOUSTOTAL : 0, 
            Z_CHECKED : true
        };
        this.LIGNES.push(_textLigneItem);
        return _textLigneItem.MD_CBMARQ;
    }

    UPDATE_DL_QTE(MD_CBMARQ : number, DL_QTE : number, AR_UNITEVEN : string){
        let M_INDEX = this.LIGNES.findIndex(a=> a.MD_CBMARQ == MD_CBMARQ);
        if(M_INDEX > - 1){
            let M = this.LIGNES[M_INDEX];
            M.DL_POIDSNET = M.DL_QTE == 0 ? 0 : (M.DL_POIDSNET! / M.DL_QTE!) * DL_QTE;
            M.DL_POIDSBRUT = M.DL_QTE == 0 ? 0 : (M.DL_POIDSBRUT! / M.DL_QTE!) * DL_QTE;
            M.DL_QTE = DL_QTE;
            M.EU_QTE = DL_QTE;
            M.EU_ENUMERE = AR_UNITEVEN;
            this.DL_RECALCUL_TOTAUX_LIGNES(M);
        }
        this.DO_RECALCUL_SOUS_TOTAUX();
        this.DO_RECALCUL_ENTETE();
    }

    UPDATE_DL_REMISE(MD_CBMARQ : number, REMISE_PARAMS : CluDiscountResult){
        let M_INDEX = this.LIGNES.findIndex(a=> a.MD_CBMARQ == MD_CBMARQ);
        if(M_INDEX > - 1){
            let M = this.LIGNES[M_INDEX];
            M.DL_REMISE01REM_TYPE = REMISE_PARAMS.DL_REMISE01REM_TYPE; M.DL_REMISE02REM_TYPE = REMISE_PARAMS.DL_REMISE02REM_TYPE; M.DL_REMISE03REM_TYPE = REMISE_PARAMS.DL_REMISE03REM_TYPE;
            M.DL_REMISE01REM_VALEUR = REMISE_PARAMS.DL_REMISE01REM_VALEUR; M.DL_REMISE02REM_VALEUR = REMISE_PARAMS.DL_REMISE02REM_VALEUR; M.DL_REMISE03REM_VALEUR = REMISE_PARAMS.DL_REMISE03REM_VALEUR;
            this.DL_RECALCUL_TOTAUX_LIGNES(M);
        }
        this.DO_RECALCUL_SOUS_TOTAUX();
        this.DO_RECALCUL_ENTETE();
    }

    UPDATE_DL_PUTTC(MD_CBMARQ : number, DL_PUTTC : number) {
        let M_INDEX = this.LIGNES.findIndex(a=> a.MD_CBMARQ == MD_CBMARQ);
        if(M_INDEX > - 1){
            let M = this.LIGNES[M_INDEX];
            if(!M.DL_TTC) return;
            M.DL_PUTTC = DL_PUTTC;
            this.DL_RECALCUL_TOTAUX_LIGNES(M);
            // FIX : OLD : M.DL_PRIXUNITAIRE = M.DL_MONTANTHT / M.DL_QTE;;
            let _m_ARTFAMCOMPTA : CluArtFamComptaItem = new CluArtFamComptaItem(); 
            _m_ARTFAMCOMPTA.DL_CODETAXE1 = M.DL_CODETAXE1; _m_ARTFAMCOMPTA.DL_TAXE1 = M.DL_TAXE1; _m_ARTFAMCOMPTA.DL_TYPETAXE1 = M.DL_TYPETAXE1; _m_ARTFAMCOMPTA.DL_TYPETAUX1 = M.DL_TYPETAUX1;
            _m_ARTFAMCOMPTA.DL_CODETAXE2 = M.DL_CODETAXE2; _m_ARTFAMCOMPTA.DL_TAXE2 = M.DL_TAXE2; _m_ARTFAMCOMPTA.DL_TYPETAXE2 = M.DL_TYPETAXE2; _m_ARTFAMCOMPTA.DL_TYPETAUX2 = M.DL_TYPETAUX2;
            _m_ARTFAMCOMPTA.DL_CODETAXE3 = M.DL_CODETAXE3; _m_ARTFAMCOMPTA.DL_TAXE3 = M.DL_TAXE3; _m_ARTFAMCOMPTA.DL_TYPETAXE3 = M.DL_TYPETAXE3; _m_ARTFAMCOMPTA.DL_TYPETAUX3 = M.DL_TYPETAUX3;
            M.DL_PRIXUNITAIRE = this.doConvertTTCtoHT(M.DL_PUTTC, M.DL_POIDSNET!, _m_ARTFAMCOMPTA);
            
        }
        this.DO_RECALCUL_SOUS_TOTAUX();
        this.DO_RECALCUL_ENTETE();
    }

    UPDATE_DL_PRIXUNITAIRE(MD_CBMARQ : number, DL_PRIXUNITAIRE : number) {
        let M_INDEX = this.LIGNES.findIndex(a=> a.MD_CBMARQ == MD_CBMARQ);
        if(M_INDEX > - 1){
            let M = this.LIGNES[M_INDEX];
            if(M.DL_TTC == 1) return;
            M.DL_PRIXUNITAIRE = DL_PRIXUNITAIRE;
            this.DL_RECALCUL_TOTAUX_LIGNES(M);
            // FIX : OLD : M.DL_PUTTC = M.DL_MONTANTTTC / M.DL_QTE;
            let _m_ARTFAMCOMPTA : CluArtFamComptaItem = new CluArtFamComptaItem(); 
            _m_ARTFAMCOMPTA.DL_CODETAXE1 = M.DL_CODETAXE1; _m_ARTFAMCOMPTA.DL_TAXE1 = M.DL_TAXE1; _m_ARTFAMCOMPTA.DL_TYPETAXE1 = M.DL_TYPETAXE1; _m_ARTFAMCOMPTA.DL_TYPETAUX1 = M.DL_TYPETAUX1;
            _m_ARTFAMCOMPTA.DL_CODETAXE2 = M.DL_CODETAXE2; _m_ARTFAMCOMPTA.DL_TAXE2 = M.DL_TAXE2; _m_ARTFAMCOMPTA.DL_TYPETAXE2 = M.DL_TYPETAXE2; _m_ARTFAMCOMPTA.DL_TYPETAUX2 = M.DL_TYPETAUX2;
            _m_ARTFAMCOMPTA.DL_CODETAXE3 = M.DL_CODETAXE3; _m_ARTFAMCOMPTA.DL_TAXE3 = M.DL_TAXE3; _m_ARTFAMCOMPTA.DL_TYPETAXE3 = M.DL_TYPETAXE3; _m_ARTFAMCOMPTA.DL_TYPETAUX3 = M.DL_TYPETAUX3;
            M.DL_PUTTC = this.doConvertHTtoTTC(M.DL_PRIXUNITAIRE, M.DL_POIDSNET!, _m_ARTFAMCOMPTA);
        }
        this.DO_RECALCUL_SOUS_TOTAUX();
        this.DO_RECALCUL_ENTETE();
    }

    UPDATE_EU_QTE(MD_CBMARQ : number, EU_QTE : number, DL_QTE : number, EU_ENUMERE : string){
        let M_INDEX = this.LIGNES.findIndex(a=> a.MD_CBMARQ == MD_CBMARQ);
        if(M_INDEX > - 1){
            let M = this.LIGNES[M_INDEX];
            M.DL_POIDSNET = M.DL_QTE == 0 ? 0 : (M.DL_POIDSNET! / M.DL_QTE!) * DL_QTE;
            M.DL_POIDSBRUT = M.DL_QTE == 0 ? 0 : (M.DL_POIDSBRUT! / M.DL_QTE!) * DL_QTE;
            M.EU_QTE = EU_QTE;
            M.DL_QTE = DL_QTE;
            M.EU_ENUMERE = EU_ENUMERE;
            //M.DL_MONTANTHT = M.DL_QTE * M.DL_PRIXUNITAIRE;
            //M.DL_MONTANTTTC = M.DL_QTE * M.DL_PUTTC!; 
            this.DL_RECALCUL_TOTAUX_LIGNES(M);
        }
        this.DO_RECALCUL_SOUS_TOTAUX();
        this.DO_RECALCUL_ENTETE();
    }

    REORDER_LIGNES(){
        this.DO_RECALCUL_SOUS_TOTAUX();
    }

    ADD_REGLEMENT(REGLEMENT : RxCluDocReglementDocumentType) : RxCluDocReglementDocumentType {
        this.REGLEMENTS = [...this.REGLEMENTS, REGLEMENT];
        this.DO_RECALCUL_ENTETE();
        return REGLEMENT;
    }

    private DO_RECALCUL_SOUS_TOTAUX(){
        const ITEMS_ARRAYS = this.splitList_SOUS_TOTAUX(this.LIGNES);
        const SOUS_TOTAUX_INDEXES = this.splitList_SOUS_TOTAUX_INDEX(this.LIGNES);
        SOUS_TOTAUX_INDEXES.forEach((SOUS_TOTAL_INDEX, INDEX) => {
            let SUB_TOTAL_ROW = this.LIGNES[SOUS_TOTAL_INDEX];
            let ITEMS_ARRAY = ITEMS_ARRAYS[INDEX];
            ITEMS_ARRAY.forEach((ITEM : RxCluDocLigneDocumentType) => {
                ITEM.DL_NOSOUSTOTAL = SUB_TOTAL_ROW.DL_NO;
            });
            let ITEMS_TO_SUM = ITEMS_ARRAY.filter(m=> m.DL_VALORISE == 1);
            SUB_TOTAL_ROW.DL_QTE = ITEMS_TO_SUM.length == 0 ? 0 : aggregateBy(ITEMS_TO_SUM, [{aggregate : 'sum', field : 'DL_QTE'}])['DL_QTE'].sum ?? 0;
            SUB_TOTAL_ROW.EU_QTE = ITEMS_TO_SUM.length == 0 ? 0 : aggregateBy(ITEMS_TO_SUM, [{aggregate : 'sum', field : 'EU_QTE'}])['EU_QTE'].sum ?? 0;
            SUB_TOTAL_ROW.DL_PRIXUNITAIRE = ITEMS_TO_SUM.length == 0 ? 0 : aggregateBy(ITEMS_TO_SUM, [{aggregate : 'sum', field : 'DL_MONTANTHT'}])['DL_MONTANTHT'].sum ?? 0;
            SUB_TOTAL_ROW.DL_PUTTC = ITEMS_TO_SUM.length == 0 ? 0 : aggregateBy(ITEMS_TO_SUM, [{aggregate : 'sum', field : 'DL_MONTANTTTC'}])['DL_MONTANTTTC'].sum ?? 0;
            SUB_TOTAL_ROW.NBLIGNES_SOUSTOTAL = ITEMS_ARRAY.length;
        });
    }

    private DO_RECALCUL_ENTETE(){
        let DL_VALORISE_ITEMS = this.LIGNES.filter(m=>m.DL_VALORISE == 1);
        if(this.ENTETE.DO_VALFRAIS && this.ENTETE.DO_VALFRAIS != 0){ DL_VALORISE_ITEMS.push(this.DL_RECALCUL_LIGNEREF_VALFRAIS()); }
        this.ENTETE.DO_TOTALHT = DL_VALORISE_ITEMS.length == 0 ? 0 : aggregateBy(DL_VALORISE_ITEMS, [{ aggregate : 'sum', field : 'DL_MONTANTHT' }])['DL_MONTANTHT'].sum ?? 0;
        this.ENTETE.DO_TOTALTTC = DL_VALORISE_ITEMS.length == 0 ? 0 : aggregateBy(DL_VALORISE_ITEMS, [{ aggregate : 'sum', field : 'DL_MONTANTTTC' }])['DL_MONTANTTTC'].sum ?? 0;
        if(this.ENTETE.DO_TXESCOMPTE && this.ENTETE.DO_TXESCOMPTE != 0){ 
            if(this.ENTETE.DO_VALFRAIS && this.ENTETE.DO_VALFRAIS != 0) { this.ENTETE.DO_TOTALTTC = this.LIGNEREF_VALFRAIS!.DL_MONTANTTTC + (this.ENTETE.DO_TOTALTTC - this.LIGNEREF_VALFRAIS!.DL_MONTANTTTC) * (100 - this.ENTETE.DO_TXESCOMPTE) / 100;  }
            else { this.ENTETE.DO_TOTALTTC = this.ENTETE.DO_TOTALTTC * (100 - this.ENTETE.DO_TXESCOMPTE) / 100;  }
        }
        this.ENTETE.DO_MONTANTREGLE = this.REGLEMENTS.length == 0 ? 0 : aggregateBy(this.REGLEMENTS, [{ aggregate : 'sum', field : 'RG_MONTANT' }])['RG_MONTANT'].sum ?? 0;
        this.ENTETE.DO_SOLDETTC = this.ENTETE.DO_TOTALTTC - this.ENTETE.DO_MONTANTREGLE;
        this.ENTETE.DO_NETAPAYER = this.ENTETE.DO_TOTALTTC;
        if([23].includes(this.ENTETE.DO_TYPE!)) {
            let DL_VALORISE_ITEMS_STOCKS_MT = DL_VALORISE_ITEMS.filter(m=>m.DE_NO != m.CT_NUM);
            this.ENTETE.DO_TOTALHT = DL_VALORISE_ITEMS_STOCKS_MT.length == 0 ? 0 : aggregateBy(DL_VALORISE_ITEMS_STOCKS_MT, [{ aggregate : 'sum', field : 'DL_MONTANTHT' }])['DL_MONTANTHT'].sum ?? 0;
            this.ENTETE.DO_TOTALTTC = DL_VALORISE_ITEMS_STOCKS_MT.length == 0 ? 0 : aggregateBy(DL_VALORISE_ITEMS_STOCKS_MT, [{ aggregate : 'sum', field : 'DL_MONTANTTTC' }])['DL_MONTANTTTC'].sum ?? 0;
        }
    }

    private DL_RECALCUL_TOTAUX_LIGNES(M : RxCluDocLigneDocumentType){
        M.DL_MONTANTHT = M.DL_QTE * M.DL_PRIXUNITAIRE;
        M.DL_MONTANTTTC = M.DL_QTE * M.DL_PUTTC!; 
        M.DL_REMISE_LIB = '';
        //if(!M.DL_REMISE01REM_VALEUR || M.DL_REMISE01REM_VALEUR == 0) return;

        let _m_ARTFAMCOMPTA : CluArtFamComptaItem = new CluArtFamComptaItem(); 
        //_m_ARTFAMCOMPTA.N_CATCOMPTA = this.ENTETE.N_CATCOMPTA;
        _m_ARTFAMCOMPTA.DL_CODETAXE1 = M.DL_CODETAXE1; _m_ARTFAMCOMPTA.DL_TAXE1 = M.DL_TAXE1; _m_ARTFAMCOMPTA.DL_TYPETAXE1 = M.DL_TYPETAXE1; _m_ARTFAMCOMPTA.DL_TYPETAUX1 = M.DL_TYPETAUX1;
        _m_ARTFAMCOMPTA.DL_CODETAXE2 = M.DL_CODETAXE2; _m_ARTFAMCOMPTA.DL_TAXE2 = M.DL_TAXE2; _m_ARTFAMCOMPTA.DL_TYPETAXE2 = M.DL_TYPETAXE2; _m_ARTFAMCOMPTA.DL_TYPETAUX2 = M.DL_TYPETAUX2;
        _m_ARTFAMCOMPTA.DL_CODETAXE3 = M.DL_CODETAXE3; _m_ARTFAMCOMPTA.DL_TAXE3 = M.DL_TAXE3; _m_ARTFAMCOMPTA.DL_TYPETAXE3 = M.DL_TYPETAXE3; _m_ARTFAMCOMPTA.DL_TYPETAUX3 = M.DL_TYPETAUX3;
        switch(M.DL_TTC){
            case 0 : 
                if(M.DL_REMISE01REM_VALEUR && M.DL_REMISE01REM_VALEUR != 0) { 
                    switch(M.DL_REMISE01REM_TYPE){
                        case 0 : M.DL_MONTANTHT = M.DL_MONTANTHT - M.DL_REMISE01REM_VALEUR; M.DL_REMISE_LIB = this.formatNumber_REMISELIB(M.DL_REMISE01REM_VALEUR) + 'F'; break; // F
                        case 1 : M.DL_MONTANTHT = M.DL_MONTANTHT * (100.0 - M.DL_REMISE01REM_VALEUR) / 100.0; M.DL_REMISE_LIB = this.formatNumber_REMISELIB(M.DL_REMISE01REM_VALEUR) + '%'; break; // %
                        case 2 : M.DL_MONTANTHT = M.DL_MONTANTHT - M.DL_QTE * M.DL_REMISE01REM_VALEUR; M.DL_REMISE_LIB = this.formatNumber_REMISELIB(M.DL_REMISE01REM_VALEUR) + 'U'; break; // U
                    }
                }
                if(M.DL_REMISE01REM_VALEUR && M.DL_REMISE01REM_VALEUR != 0 && M.DL_REMISE02REM_VALEUR && M.DL_REMISE02REM_VALEUR != 0) { 
                    switch(M.DL_REMISE02REM_TYPE){
                        case 0 : M.DL_MONTANTHT = M.DL_MONTANTHT - M.DL_REMISE02REM_VALEUR; M.DL_REMISE_LIB += (M.DL_REMISE02REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE02REM_VALEUR) + 'F'; break; // F
                        case 1 : M.DL_MONTANTHT = M.DL_MONTANTHT * (100.0 - M.DL_REMISE02REM_VALEUR) / 100.0; M.DL_REMISE_LIB += (M.DL_REMISE02REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE02REM_VALEUR) + '%'; break; // %
                        case 2 : M.DL_MONTANTHT = M.DL_MONTANTHT - M.DL_QTE * M.DL_REMISE02REM_VALEUR; M.DL_REMISE_LIB += (M.DL_REMISE02REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE02REM_VALEUR) + 'U'; break; // U
                    }
                }
                if(M.DL_REMISE01REM_VALEUR && M.DL_REMISE01REM_VALEUR != 0 && M.DL_REMISE02REM_VALEUR && M.DL_REMISE02REM_VALEUR != 0 && M.DL_REMISE03REM_VALEUR && M.DL_REMISE03REM_VALEUR != 0) { 
                    switch(M.DL_REMISE03REM_TYPE){
                        case 0 : M.DL_MONTANTHT = M.DL_MONTANTHT - M.DL_REMISE03REM_VALEUR; M.DL_REMISE_LIB += (M.DL_REMISE03REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE03REM_VALEUR) + 'F'; break; // F
                        case 1 : M.DL_MONTANTHT = M.DL_MONTANTHT * (100.0 - M.DL_REMISE03REM_VALEUR) / 100.0; M.DL_REMISE_LIB += (M.DL_REMISE03REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE03REM_VALEUR) + '%'; break; // %
                        case 2 : M.DL_MONTANTHT = M.DL_MONTANTHT - M.DL_QTE * M.DL_REMISE03REM_VALEUR; M.DL_REMISE_LIB += (M.DL_REMISE03REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE03REM_VALEUR) + 'U'; break; // U
                    }
                }
                M.DL_MONTANTTTC = this.doConvertHTtoTTC(M.DL_MONTANTHT, M.DL_POIDSNET!, _m_ARTFAMCOMPTA);
                break;
            case 1 : 
                if(M.DL_REMISE01REM_VALEUR && M.DL_REMISE01REM_VALEUR != 0) { 
                    switch(M.DL_REMISE01REM_TYPE){
                        case 0 : M.DL_MONTANTTTC = M.DL_MONTANTTTC - M.DL_REMISE01REM_VALEUR; M.DL_REMISE_LIB = this.formatNumber_REMISELIB(M.DL_REMISE01REM_VALEUR) + 'F'; break; // F
                        case 1 : M.DL_MONTANTTTC = M.DL_MONTANTTTC * (100.0 - M.DL_REMISE01REM_VALEUR) / 100.0; M.DL_REMISE_LIB = this.formatNumber_REMISELIB(M.DL_REMISE01REM_VALEUR) + '%'; break; // %
                        case 2 : M.DL_MONTANTTTC = M.DL_MONTANTTTC - M.DL_QTE * M.DL_REMISE01REM_VALEUR; M.DL_REMISE_LIB = this.formatNumber_REMISELIB(M.DL_REMISE01REM_VALEUR) + 'U'; break; // U
                    }
                }
                if(M.DL_REMISE01REM_VALEUR && M.DL_REMISE01REM_VALEUR != 0 && M.DL_REMISE02REM_VALEUR && M.DL_REMISE02REM_VALEUR != 0) { 
                    switch(M.DL_REMISE02REM_TYPE){
                        case 0 : M.DL_MONTANTTTC = M.DL_MONTANTTTC - M.DL_REMISE02REM_VALEUR; M.DL_REMISE_LIB += (M.DL_REMISE02REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE02REM_VALEUR) + 'F'; break; // F
                        case 1 : M.DL_MONTANTTTC = M.DL_MONTANTTTC * (100.0 - M.DL_REMISE02REM_VALEUR) / 100.0; M.DL_REMISE_LIB += (M.DL_REMISE02REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE02REM_VALEUR) + '%'; break; // %
                        case 2 : M.DL_MONTANTTTC = M.DL_MONTANTTTC - M.DL_QTE * M.DL_REMISE02REM_VALEUR; M.DL_REMISE_LIB += (M.DL_REMISE02REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE02REM_VALEUR) + 'U'; break; // U
                    }
                }
                if(M.DL_REMISE01REM_VALEUR && M.DL_REMISE01REM_VALEUR != 0 && M.DL_REMISE02REM_VALEUR && M.DL_REMISE02REM_VALEUR != 0 && M.DL_REMISE03REM_VALEUR && M.DL_REMISE03REM_VALEUR != 0) { 
                    switch(M.DL_REMISE03REM_TYPE){
                        case 0 : M.DL_MONTANTTTC = M.DL_MONTANTTTC - M.DL_REMISE03REM_VALEUR; M.DL_REMISE_LIB += (M.DL_REMISE03REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE03REM_VALEUR) + 'F'; break; // F
                        case 1 : M.DL_MONTANTTTC = M.DL_MONTANTTTC * (100.0 - M.DL_REMISE03REM_VALEUR) / 100.0; M.DL_REMISE_LIB += (M.DL_REMISE03REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE03REM_VALEUR) + '%'; break; // %
                        case 2 : M.DL_MONTANTTTC = M.DL_MONTANTTTC - M.DL_QTE * M.DL_REMISE03REM_VALEUR; M.DL_REMISE_LIB += (M.DL_REMISE03REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE03REM_VALEUR) + 'U'; break; // U
                    }
                }
                M.DL_MONTANTHT = this.doConvertTTCtoHT(M.DL_MONTANTTTC, M.DL_POIDSNET!, _m_ARTFAMCOMPTA);
                break;
        }
        M.DL_PRIXUNITAIRE_NET = M.DL_MONTANTHT / M.DL_QTE;
        M.DL_PUTTC_NET = M.DL_MONTANTTTC / M.DL_QTE;
    }
    
    FORCE_RECALCUL_TOTAUX(){
        this.DO_RECALCUL_SOUS_TOTAUX();
        this.DO_RECALCUL_ENTETE();
    }

    GET_BILAN_TAXES_BKP(_fTaxeItems : RxFTaxeDocumentType[] | undefined = undefined) : CluBilanTaxeItem[] {
        let T_RESULTS : any = {};
        let LIGNES = JSON.parse(JSON.stringify(this.LIGNES.filter(m=> m.DL_VALORISE == 1)));
        LIGNES.forEach((dlItem : any) => {
            let TAXES_T0T1 : any[] = []; let TAXES_T2 : any[] = []; let TAXES_T3 : any[] = []; let TAXES_OTHERS : any[] = [];
            if(dlItem.DL_CODETAXE1 && dlItem.DL_TAXE1 != 0) { 
                T_RESULTS[dlItem.DL_CODETAXE1] = { B_ITEMS : [] };
                if([0,1].indexOf(dlItem.DL_TYPETAXE1!) > -1) { TAXES_T0T1.push({ DL_CODETAXE : dlItem.DL_CODETAXE1, DL_TYPETAXE : dlItem.DL_TYPETAXE1, DL_TAXE : dlItem.DL_TAXE1 }); } 
                else if ([2].indexOf(dlItem.DL_TYPETAXE1!) > -1) { TAXES_T2.push({ DL_CODETAXE : dlItem.DL_CODETAXE1, DL_TYPETAXE : dlItem.DL_TYPETAXE1, DL_TAXE : dlItem.DL_TAXE1 }); } 
                else if ([3].indexOf(dlItem.DL_TYPETAXE1!) > -1) { TAXES_T3.push({ DL_CODETAXE : dlItem.DL_CODETAXE1, DL_TYPETAXE : dlItem.DL_TYPETAXE1, DL_TAXE : dlItem.DL_TAXE1 }); } 
                else { TAXES_OTHERS.push({ DL_CODETAXE : dlItem.DL_CODETAXE1, DL_TYPETAXE : dlItem.DL_TYPETAXE1, DL_TAXE : dlItem.DL_TAXE1 }); }
            }
            if(dlItem.DL_CODETAXE2 && dlItem.DL_TAXE2 != 0) { 
                T_RESULTS[dlItem.DL_CODETAXE2] = { B_ITEMS : [] };
                if([0,1].indexOf(dlItem.DL_TYPETAXE2!) > -1) { TAXES_T0T1.push({ DL_CODETAXE : dlItem.DL_CODETAXE2, DL_TYPETAXE : dlItem.DL_TYPETAXE2, DL_TAXE : dlItem.DL_TAXE2 }); } 
                else if ([2].indexOf(dlItem.DL_TYPETAXE2!) > -1) { TAXES_T2.push({ DL_CODETAXE : dlItem.DL_CODETAXE2, DL_TYPETAXE : dlItem.DL_TYPETAXE2, DL_TAXE : dlItem.DL_TAXE2 }); } 
                else if ([3].indexOf(dlItem.DL_TYPETAXE2!) > -1) { TAXES_T3.push({ DL_CODETAXE : dlItem.DL_CODETAXE2, DL_TYPETAXE : dlItem.DL_TYPETAXE2, DL_TAXE : dlItem.DL_TAXE2 }); } 
                else { TAXES_OTHERS.push({ DL_CODETAXE : dlItem.DL_CODETAXE2, DL_TYPETAXE : dlItem.DL_TYPETAXE2, DL_TAXE : dlItem.DL_TAXE2 }); }
            }
            if(dlItem.DL_CODETAXE3 && dlItem.DL_TAXE3 != 0) { 
                T_RESULTS[dlItem.DL_CODETAXE3] = { B_ITEMS : [] };
                if([0,1].indexOf(dlItem.DL_TYPETAXE3!) > -1) { TAXES_T0T1.push({ DL_CODETAXE : dlItem.DL_CODETAXE3, DL_TYPETAXE : dlItem.DL_TYPETAXE3, DL_TAXE : dlItem.DL_TAXE3 }); } 
                else if ([2].indexOf(dlItem.DL_TYPETAXE3!) > -1) { TAXES_T2.push({ DL_CODETAXE : dlItem.DL_CODETAXE3, DL_TYPETAXE : dlItem.DL_TYPETAXE3, DL_TAXE : dlItem.DL_TAXE3 }); } 
                else if ([3].indexOf(dlItem.DL_TYPETAXE3!) > -1) { TAXES_T3.push({ DL_CODETAXE : dlItem.DL_CODETAXE3, DL_TYPETAXE : dlItem.DL_TYPETAXE3, DL_TAXE : dlItem.DL_TAXE3 }); } 
                else { TAXES_OTHERS.push({ DL_CODETAXE : dlItem.DL_CODETAXE3, DL_TYPETAXE : dlItem.DL_TYPETAXE3, DL_TAXE : dlItem.DL_TAXE3 }); }
            }
            dlItem.TAXES_T0T1 = TAXES_T0T1; dlItem.TAXES_T2 = TAXES_T2; dlItem.TAXES_T3 = TAXES_T3; dlItem.TAXES_OTHERS = TAXES_OTHERS;
        });
        LIGNES.forEach((dlItem : any) => {
            dlItem.TAXES_T2.forEach((m : any) => { T_RESULTS[m.DL_CODETAXE].B_ITEMS.push({ DL_ITEM : dlItem, TAXE : m, T_BASE : dlItem.DL_MONTANTHT }); });
            dlItem.TAXES_T0T1.forEach((m : any) => { T_RESULTS[m.DL_CODETAXE].B_ITEMS.push({ DL_ITEM : dlItem, TAXE : m, T_BASE : dlItem.DL_MONTANTHT * (1 + dlItem.TAXES_T2.map((w : any) => w.DL_TAXE).reduce((a : number, b : number) => a + b, 0) / 100.0000000) }); });
            dlItem.TAXES_T3.forEach((m : any) => { T_RESULTS[m.DL_CODETAXE].B_ITEMS.push({ DL_ITEM : dlItem, TAXE : m, T_BASE : dlItem.DL_MONTANTHT * (1 + dlItem.TAXES_T2.map((w : any) => w.DL_TAXE).reduce((a : number, b : number) => a + b, 0) / 100.0000000) * (1 + dlItem.TAXES_T0T1.map((w : any) => w.DL_TAXE).reduce((a : number, b : number) => a + b, 0) / 100.0000000) }); });
        });
        Object.keys(T_RESULTS).forEach(code => {
            T_RESULTS[code].T_BASE = T_RESULTS[code].B_ITEMS.map((w : any) => w.T_BASE).reduce((a : number, b : number) => a + b, 0);
            T_RESULTS[code].T_TAUX = T_RESULTS[code].B_ITEMS[0].TAXE.DL_TAXE;
            T_RESULTS[code].T_MONTANT = T_RESULTS[code].T_BASE * T_RESULTS[code].T_TAUX / 100.000000;
        });
        let B_ITEMS : CluBilanTaxeItem[] = [];
        Object.keys(T_RESULTS).forEach(code => {
            let B_ITEM = new CluBilanTaxeItem();
            B_ITEM.DL_CODETAXE = code;
            B_ITEM.T_BASE = T_RESULTS[code].T_BASE;
            B_ITEM.T_TAUX = T_RESULTS[code].T_TAUX;
            B_ITEM.T_MONTANT = T_RESULTS[code].T_MONTANT;
            B_ITEMS.push(B_ITEM);
        });
        if(_fTaxeItems && _fTaxeItems.length > 0) { 
            B_ITEMS.forEach((m : CluBilanTaxeItem) => {
                let _mTaxe = _fTaxeItems.find(w=> w.TA_CODE == m.DL_CODETAXE);
                if(_mTaxe) { m.DL_TAXELIB = _mTaxe.TA_INTITULE!; }
            });
        }
        return B_ITEMS;
    }
    
    GET_BILAN_TAXES(_fTaxeItems : RxFTaxeDocumentType[] | undefined = undefined) : CluBilanTaxeItem[] {
        let T_RESULTS : any = {};
        let LIGNES = JSON.parse(JSON.stringify(this.LIGNES.filter(m=> m.DL_VALORISE == 1)));
        if(this.ENTETE.DO_VALFRAIS && this.ENTETE.DO_VALFRAIS != 0){ LIGNES.push(this.DL_RECALCUL_LIGNEREF_VALFRAIS()); }
        // #region FIX : Cas où il y a des lignes avec des taxes 2 ou 3 sans taxe 1 et les cas des lignes avec des taxes 3 sans taxe 2
        LIGNES.forEach((dlItem: any) => {
            if((!dlItem.DL_CODETAXE1 && (dlItem.DL_CODETAXE2 || dlItem.DL_CODETAXE3)) || (!dlItem.DL_CODETAXE2 && (dlItem.DL_CODETAXE3))) {
                const taxes = [
                    { code: dlItem.DL_CODETAXE1, taxe: dlItem.DL_TAXE1, typeTaxe: dlItem.DL_TYPETAXE1, typeTaux: dlItem.DL_TYPETAUX1 },
                    { code: dlItem.DL_CODETAXE2, taxe: dlItem.DL_TAXE2, typeTaxe: dlItem.DL_TYPETAXE2, typeTaux: dlItem.DL_TYPETAUX2 },
                    { code: dlItem.DL_CODETAXE3, taxe: dlItem.DL_TAXE3, typeTaxe: dlItem.DL_TYPETAXE3, typeTaux: dlItem.DL_TYPETAUX3 }
                ].filter(t => !!t.code);

                while (taxes.length < 3) {
                    taxes.push({ code: '', taxe: 0, typeTaxe: 1, typeTaux: 0 });
                }

                taxes.forEach((t, index) => {
                    const i = index + 1;
                    dlItem[`DL_CODETAXE${i}`] = t.code; dlItem[`DL_TAXE${i}`] = t.taxe; dlItem[`DL_TYPETAXE${i}`] = t.typeTaxe; dlItem[`DL_TYPETAUX${i}`] = t.typeTaux;
                });
            }
        });
        LIGNES.forEach((dlItem : any) => {
            let TAXES_T0T1 : any[] = []; let TAXES_T2 : any[] = []; let TAXES_T3 : any[] = []; let TAXES_T4 : any[] = []; let TAXES_OTHERS : any[] = [];
            if(dlItem.DL_CODETAXE1 && dlItem.DL_TAXE1 != 0) { 
                T_RESULTS[dlItem.DL_CODETAXE1] = { B_ITEMS : [] };
                if([0,1].indexOf(dlItem.DL_TYPETAXE1!) > -1) { TAXES_T0T1.push({ DL_CODETAXE : dlItem.DL_CODETAXE1, DL_TYPETAXE : dlItem.DL_TYPETAXE1, DL_TAXE : dlItem.DL_TAXE1 }); } 
                else if ([2].indexOf(dlItem.DL_TYPETAXE1!) > -1) { TAXES_T2.push({ DL_CODETAXE : dlItem.DL_CODETAXE1, DL_TYPETAXE : dlItem.DL_TYPETAXE1, DL_TAXE : dlItem.DL_TAXE1 }); } 
                else if ([3].indexOf(dlItem.DL_TYPETAXE1!) > -1) { TAXES_T3.push({ DL_CODETAXE : dlItem.DL_CODETAXE1, DL_TYPETAXE : dlItem.DL_TYPETAXE1, DL_TAXE : dlItem.DL_TAXE1 }); } 
                else if ([4].indexOf(dlItem.DL_TYPETAXE1!) > -1) { TAXES_T4.push({ DL_CODETAXE : dlItem.DL_CODETAXE1, DL_TYPETAXE : dlItem.DL_TYPETAXE1, DL_TAXE : dlItem.DL_TAXE1 }); } 
                else { TAXES_OTHERS.push({ DL_CODETAXE : dlItem.DL_CODETAXE1, DL_TYPETAXE : dlItem.DL_TYPETAXE1, DL_TAXE : dlItem.DL_TAXE1 }); }
            }
            if(dlItem.DL_CODETAXE2 && dlItem.DL_TAXE2 != 0) { 
                T_RESULTS[dlItem.DL_CODETAXE2] = { B_ITEMS : [] };
                if([0,1].indexOf(dlItem.DL_TYPETAXE2!) > -1) { TAXES_T0T1.push({ DL_CODETAXE : dlItem.DL_CODETAXE2, DL_TYPETAXE : dlItem.DL_TYPETAXE2, DL_TAXE : dlItem.DL_TAXE2 }); } 
                else if ([2].indexOf(dlItem.DL_TYPETAXE2!) > -1) { TAXES_T2.push({ DL_CODETAXE : dlItem.DL_CODETAXE2, DL_TYPETAXE : dlItem.DL_TYPETAXE2, DL_TAXE : dlItem.DL_TAXE2 }); } 
                else if ([3].indexOf(dlItem.DL_TYPETAXE2!) > -1) { TAXES_T3.push({ DL_CODETAXE : dlItem.DL_CODETAXE2, DL_TYPETAXE : dlItem.DL_TYPETAXE2, DL_TAXE : dlItem.DL_TAXE2 }); } 
                else if ([4].indexOf(dlItem.DL_TYPETAXE2!) > -1) { TAXES_T4.push({ DL_CODETAXE : dlItem.DL_CODETAXE2, DL_TYPETAXE : dlItem.DL_TYPETAXE2, DL_TAXE : dlItem.DL_TAXE2 }); } 
                else { TAXES_OTHERS.push({ DL_CODETAXE : dlItem.DL_CODETAXE2, DL_TYPETAXE : dlItem.DL_TYPETAXE2, DL_TAXE : dlItem.DL_TAXE2 }); }
            }
            if(dlItem.DL_CODETAXE3 && dlItem.DL_TAXE3 != 0) { 
                T_RESULTS[dlItem.DL_CODETAXE3] = { B_ITEMS : [] };
                if([0,1].indexOf(dlItem.DL_TYPETAXE3!) > -1) { TAXES_T0T1.push({ DL_CODETAXE : dlItem.DL_CODETAXE3, DL_TYPETAXE : dlItem.DL_TYPETAXE3, DL_TAXE : dlItem.DL_TAXE3 }); } 
                else if ([2].indexOf(dlItem.DL_TYPETAXE3!) > -1) { TAXES_T2.push({ DL_CODETAXE : dlItem.DL_CODETAXE3, DL_TYPETAXE : dlItem.DL_TYPETAXE3, DL_TAXE : dlItem.DL_TAXE3 }); } 
                else if ([3].indexOf(dlItem.DL_TYPETAXE3!) > -1) { TAXES_T3.push({ DL_CODETAXE : dlItem.DL_CODETAXE3, DL_TYPETAXE : dlItem.DL_TYPETAXE3, DL_TAXE : dlItem.DL_TAXE3 }); } 
                else if ([4].indexOf(dlItem.DL_TYPETAXE3!) > -1) { TAXES_T4.push({ DL_CODETAXE : dlItem.DL_CODETAXE3, DL_TYPETAXE : dlItem.DL_TYPETAXE3, DL_TAXE : dlItem.DL_TAXE3 }); } 
                else { TAXES_OTHERS.push({ DL_CODETAXE : dlItem.DL_CODETAXE3, DL_TYPETAXE : dlItem.DL_TYPETAXE3, DL_TAXE : dlItem.DL_TAXE3 }); }
            }
            dlItem.TAXES_T0T1 = TAXES_T0T1; dlItem.TAXES_T2 = TAXES_T2; dlItem.TAXES_T3 = TAXES_T3; dlItem.TAXES_T4 = TAXES_T4; dlItem.TAXES_OTHERS = TAXES_OTHERS;
        });
        LIGNES.forEach((dlItem : any) => {
            dlItem.TAXES_T2.forEach((m : any) => { T_RESULTS[m.DL_CODETAXE].B_ITEMS.push({ DL_ITEM : dlItem, TAXE : m, T_BASE : dlItem.DL_MONTANTHT }); });
            dlItem.TAXES_T0T1.forEach((m : any) => { T_RESULTS[m.DL_CODETAXE].B_ITEMS.push({ DL_ITEM : dlItem, TAXE : m, T_BASE : dlItem.DL_MONTANTHT * (1 + dlItem.TAXES_T2.map((w : any) => w.DL_TAXE).reduce((a : number, b : number) => a + b, 0) / 100.0000000) }); });
            dlItem.TAXES_T3.forEach((m : any) => { T_RESULTS[m.DL_CODETAXE].B_ITEMS.push({ DL_ITEM : dlItem, TAXE : m, T_BASE : dlItem.DL_MONTANTHT * (1 + dlItem.TAXES_T2.map((w : any) => w.DL_TAXE).reduce((a : number, b : number) => a + b, 0) / 100.0000000) * (1 + dlItem.TAXES_T0T1.map((w : any) => w.DL_TAXE).reduce((a : number, b : number) => a + b, 0) / 100.0000000) }); });
            dlItem.TAXES_T4.forEach((m : any) => { T_RESULTS[m.DL_CODETAXE].B_ITEMS.push({ DL_ITEM : dlItem, TAXE : m, T_BASE : dlItem.DL_POIDSNET }); });
        });
        Object.keys(T_RESULTS).forEach(code => {
            T_RESULTS[code].T_BASE = T_RESULTS[code].B_ITEMS.map((w : any) => w.T_BASE).reduce((a : number, b : number) => a + b, 0);
            T_RESULTS[code].T_TAUX = T_RESULTS[code].B_ITEMS[0].TAXE.DL_TAXE;
            T_RESULTS[code].T_MONTANT = T_RESULTS[code].T_BASE * T_RESULTS[code].T_TAUX / 100.000000;
            
            T_RESULTS[code].T_BASE_VALFRAIS = 0;
            T_RESULTS[code].T_MONTANT_VALFRAIS = 0;
            if(this.ENTETE.DO_VALFRAIS && this.ENTETE.DO_VALFRAIS != 0) { 
                T_RESULTS[code].T_BASE_VALFRAIS = T_RESULTS[code].B_ITEMS.filter((m : any) => m.DL_ITEM.DL_DESIGN == 'CLU_VALFRAIS').map((w : any) => w.T_BASE).reduce((a : number, b : number) => a + b, 0);
                T_RESULTS[code].T_MONTANT_VALFRAIS = T_RESULTS[code].T_BASE_VALFRAIS * T_RESULTS[code].T_TAUX / 100.000000;
            } 
        });
        let B_ITEMS : CluBilanTaxeItem[] = [];
        Object.keys(T_RESULTS).forEach(code => {
            let B_ITEM = new CluBilanTaxeItem();
            B_ITEM.DL_CODETAXE = code;
            B_ITEM.T_BASE = T_RESULTS[code].T_BASE;
            B_ITEM.T_TAUX = T_RESULTS[code].T_TAUX;
            B_ITEM.T_MONTANT = T_RESULTS[code].T_MONTANT;
            B_ITEMS.push(B_ITEM);
        });
        if(this.ENTETE.DO_TXESCOMPTE && this.ENTETE.DO_TXESCOMPTE != 0){
            B_ITEMS.forEach((m : CluBilanTaxeItem) => { 
                if(this.ENTETE.DO_VALFRAIS && this.ENTETE.DO_VALFRAIS != 0) { 
                    let T_BASE_VALFRAIS = T_RESULTS[m.DL_CODETAXE].T_BASE_VALFRAIS;
                    m.T_BASE = (T_BASE_VALFRAIS + (Number(m.T_BASE) - T_BASE_VALFRAIS) * (100 - this.ENTETE.DO_TXESCOMPTE!) / 100).toString(); 
                    m.T_MONTANT = Number(m.T_BASE) * m.T_TAUX / 100.000000; 
                }
                else {
                    m.T_BASE = (Number(m.T_BASE) * (100 - this.ENTETE.DO_TXESCOMPTE!) / 100).toString(); 
                    m.T_MONTANT = Number(m.T_BASE) * m.T_TAUX / 100.000000; 
                }
            });
            let B_ITEM_ESCOMPTE = new CluBilanTaxeItem();
            B_ITEM_ESCOMPTE.DL_CODETAXE = 'TA_ESCOMPTE';
            B_ITEM_ESCOMPTE.DL_TAXELIB = 'Escompte à ' + this.ENTETE.DO_TXESCOMPTE.toString() + '%';
            if(this.ENTETE.DO_VALFRAIS && this.ENTETE.DO_VALFRAIS != 0) { this.DL_RECALCUL_LIGNEREF_VALFRAIS(); B_ITEM_ESCOMPTE.T_BASE = (this.ENTETE.DO_TOTALHT - this.LIGNEREF_VALFRAIS!.DL_MONTANTHT).toString(); } 
            else { B_ITEM_ESCOMPTE.T_BASE = this.ENTETE.DO_TOTALHT.toString(); }
            B_ITEM_ESCOMPTE.T_TAUX = this.ENTETE.DO_TXESCOMPTE;
            B_ITEM_ESCOMPTE.T_MONTANT = Number(B_ITEM_ESCOMPTE.T_BASE) * B_ITEM_ESCOMPTE.T_TAUX / 100.000000;
            B_ITEMS.unshift(B_ITEM_ESCOMPTE);
        }
        if(_fTaxeItems && _fTaxeItems.length > 0) { 
            B_ITEMS.forEach((m : CluBilanTaxeItem) => {
                let _mTaxe = _fTaxeItems.find(w=> w.TA_CODE == m.DL_CODETAXE);
                if(_mTaxe) { m.DL_TAXELIB = _mTaxe.TA_INTITULE!; }
            });
        }
        return B_ITEMS;
    }

    // #region HELPER FNs
    GENERATE_LIGNE_HELPER_FN(_pItem : RxFArticleDocument, _cItem : CluDocContextItem, _nItem : CluNomenclatureItem | undefined, _lsItem : CluLotSeriePickedItemResult | undefined, _lcRParams : CluLoyaltyCardRecompenseParams | undefined, _gfPickedRes : CluCarteCadeauxItemPickedResult | undefined, DL_QTE : number | undefined) : RxCluDocLigneDocumentType {
        let _domaine = this.doGetDomaineFromDocumentTypeUtils_RemDocs(this.ENTETE.DO_TYPE!);
        // #region SPECIFICITES TARIFAIRES
        // RECHERCHE SPEC TARIF : FICHE ARTICLE, PAR DEFAULT
        let DL_TTC = _pItem.AR_PRIXTTCLIB == 'PV TTC' ? 1 : 0;
        //let DL_PU = _cItem.COMPTET.CT_TYPE == 1 ? _pItem.AR_PRIXACH! : _pItem.AR_PRIXVEN; 
        let DL_PU = _pItem.AR_PRIXVEN; 
        if(_domaine == 1) { DL_PU = _pItem.AR_PRIXACH!; }
        else if(_domaine == 2) { DL_PU = _pItem.AR_PRIXACH!; }
        else if(_domaine == 4) { DL_PU = _pItem.AR_PRIXACH!; }
        switch(_domaine) { // _cItem.COMPTET.CT_TYPE
            case 1 : 
                // RECHERCHE SPEC TARIF : FOURNISSEUR 
                let _spec_FOURNISS = _cItem.ARTFOURNISS_ITEMS.find(m=> m.CT_NUM == _cItem.COMPTET.CT_NUM);
                if(_spec_FOURNISS) { 
                    DL_PU = _spec_FOURNISS.AF_PRIXACH!;
                }
                break;
            case 2 :
                break;
            case 4 :
                break;
            case 0 :
            default : 
                // RECHERCHE SPEC TARIF : CLIENT 
                let _spec_CLIENT = _cItem.ARTCLIENT_ITEMS.find(m=> m.AC_CATEGORIE == 0 && m.CT_NUM == _cItem.COMPTET.CT_NUM);
                if(_spec_CLIENT) { 
                    DL_TTC = _spec_CLIENT.AC_PRIXTTC!;
                    DL_PU = _spec_CLIENT.AC_PRIXVEN;
                }
                else {
                    // RECHERCHE SPEC TARIF : CATEGORIE TARIFAIRE CLIENT
                    let _spec_CATTARIF = _cItem.ARTCLIENT_ITEMS.find(m=> m.AC_CATEGORIE == _cItem.COMPTET.N_CATTARIF);
                    if(_spec_CATTARIF){
                        DL_TTC = _spec_CATTARIF.AC_PRIXTTC!;
                        DL_PU = _spec_CATTARIF.AC_PRIXVEN;
                    }
                }
                break;
        }
        if(_nItem != undefined && _nItem.REF_ARTICLE_ARTGAMME != undefined) {
            // RECHERCHE SPEC TARIF : DECLINAISON TARIF PAR GAMME
            let TARIFGAM_ITEMS = _cItem.TARIFGAM_ITEMS.filter(m=> m.AG_NO1 == _nItem.REF_ARTICLE_ARTGAMME?.AG_NO1 &&  m.AG_NO2 == _nItem.REF_ARTICLE_ARTGAMME?.AG_NO2 && m.TG_PRIX! != 0);
            // RECHERCHE SPEC TARIF : DECLINAISON TARIF PAR GAMME - COMPTET
            if(_cItem.COMPTET) {
                let _specTARIFGAM_COMPTET = TARIFGAM_ITEMS.find(m=> m.TG_REFCF == _cItem.COMPTET.CT_NUM);
                if(_specTARIFGAM_COMPTET) { DL_PU = _specTARIFGAM_COMPTET.TG_PRIX!; }
                else {
                    // RECHERCHE SPEC TARIF : DECLINAISON TARIF PAR GAMME - CATEGORIE TARIFAIRE
                    let _specTARIFGAM_CATTARIF = TARIFGAM_ITEMS.find(m=> m.TG_REFCF.replace('a', '') == _cItem.COMPTET.N_CATTARIF?.toString().padStart(2, '0'));
                    if(_specTARIFGAM_CATTARIF){ DL_PU = _specTARIFGAM_CATTARIF.TG_PRIX!; }
                }
            }
        }
        // #endregion 
        let N_CATCOMPTA = _domaine == 0 || _domaine == 1 ? _cItem.COMPTET.N_CATCOMPTA : (this.ENTETE.N_CATCOMPTA ?? 1);
        let DL_TAXE1 = 0, DL_CODETAXE1 = '', DL_TYPETAUX1 = 0, DL_TYPETAXE1 = 0;
        let DL_TAXE2 = 0, DL_CODETAXE2 = '', DL_TYPETAUX2 = 0, DL_TYPETAXE2 = 0;
        let DL_TAXE3 = 0, DL_CODETAXE3 = '', DL_TYPETAUX3 = 0, DL_TYPETAXE3 = 0;
        let _m_ARTFAMCOMPTA : CluArtFamComptaItem | undefined = undefined;
        let _m_ARTCOMPTA = _cItem.ARTCOMPTA_ITEMS.find(m=> m.N_CATCOMPTA == N_CATCOMPTA); // _cItem.COMPTET.N_CATCOMPTA
        if(_m_ARTCOMPTA) {
            if ((!_m_ARTCOMPTA.DL_CODETAXE1 && (_m_ARTCOMPTA.DL_CODETAXE2 || _m_ARTCOMPTA.DL_CODETAXE3)) || (!_m_ARTCOMPTA.DL_CODETAXE2 && (_m_ARTCOMPTA.DL_CODETAXE3))) { 
                alert("Linkup ne traite pas correctement les cas où il y a des taxes 2 ou 3 sans taxe 1 et les cas avec une taxe 3 sans taxe 2. Veuillez vérifier la configuration comptable de l'article " + _pItem.AR_REF + " et corriger les éventuelles incohérences (il doit y avoir une taxe 1 si il y a une taxe 2 ou 3 et il doit y avoir une taxe 2 si il y a une taxe 3). Merci de votre compréhension." );
            }
            if(!_m_ARTCOMPTA.DL_CODETAXE1){
                _m_ARTFAMCOMPTA = new CluArtFamComptaItem(); 
                _m_ARTFAMCOMPTA.N_CATCOMPTA = _m_ARTCOMPTA.N_CATCOMPTA;
                _m_ARTFAMCOMPTA.DL_CODETAXE1 = ''; _m_ARTFAMCOMPTA.DL_LIBTAXE1 = ''; _m_ARTFAMCOMPTA.DL_TAXE1 = 0; _m_ARTFAMCOMPTA.DL_TYPETAXE1 = 0; _m_ARTFAMCOMPTA.DL_TYPETAUX1 = 0;
                _m_ARTFAMCOMPTA.DL_CODETAXE2 = ''; _m_ARTFAMCOMPTA.DL_LIBTAXE2 = ''; _m_ARTFAMCOMPTA.DL_TAXE2 = 0; _m_ARTFAMCOMPTA.DL_TYPETAXE2 = 0; _m_ARTFAMCOMPTA.DL_TYPETAUX2 = 0;
                _m_ARTFAMCOMPTA.DL_CODETAXE3 = ''; _m_ARTFAMCOMPTA.DL_LIBTAXE3 = ''; _m_ARTFAMCOMPTA.DL_TAXE3 = 0; _m_ARTFAMCOMPTA.DL_TYPETAXE3 = 0; _m_ARTFAMCOMPTA.DL_TYPETAUX3 = 0;
            }
            else {
                DL_TAXE1 = _m_ARTCOMPTA.DL_TAXE1!; DL_CODETAXE1 = _m_ARTCOMPTA.DL_CODETAXE1!; DL_TYPETAUX1 = _m_ARTCOMPTA.DL_TYPETAUX1!; DL_TYPETAXE1 = _m_ARTCOMPTA.DL_TYPETAXE1!;
                DL_TAXE2 = _m_ARTCOMPTA.DL_TAXE2!; DL_CODETAXE2 = _m_ARTCOMPTA.DL_CODETAXE2!; DL_TYPETAUX2 = _m_ARTCOMPTA.DL_TYPETAUX2!; DL_TYPETAXE2 = _m_ARTCOMPTA.DL_TYPETAXE2!;
                DL_TAXE3 = _m_ARTCOMPTA.DL_TAXE3!; DL_CODETAXE3 = _m_ARTCOMPTA.DL_CODETAXE3!; DL_TYPETAUX3 = _m_ARTCOMPTA.DL_TYPETAUX3!; DL_TYPETAXE3 = _m_ARTCOMPTA.DL_TYPETAXE3!;
                _m_ARTFAMCOMPTA = new CluArtFamComptaItem(); 
                _m_ARTFAMCOMPTA.N_CATCOMPTA = _m_ARTCOMPTA.N_CATCOMPTA;
                _m_ARTFAMCOMPTA.DL_CODETAXE1 = _m_ARTCOMPTA.DL_CODETAXE1; _m_ARTFAMCOMPTA.DL_LIBTAXE1 = _m_ARTCOMPTA.DL_LIBTAXE1; _m_ARTFAMCOMPTA.DL_TAXE1 = _m_ARTCOMPTA.DL_TAXE1; _m_ARTFAMCOMPTA.DL_TYPETAXE1 = _m_ARTCOMPTA.DL_TYPETAXE1; _m_ARTFAMCOMPTA.DL_TYPETAUX1 = _m_ARTCOMPTA.DL_TYPETAUX1;
                _m_ARTFAMCOMPTA.DL_CODETAXE2 = _m_ARTCOMPTA.DL_CODETAXE2; _m_ARTFAMCOMPTA.DL_LIBTAXE2 = _m_ARTCOMPTA.DL_LIBTAXE2; _m_ARTFAMCOMPTA.DL_TAXE2 = _m_ARTCOMPTA.DL_TAXE2; _m_ARTFAMCOMPTA.DL_TYPETAXE2 = _m_ARTCOMPTA.DL_TYPETAXE2; _m_ARTFAMCOMPTA.DL_TYPETAUX2 = _m_ARTCOMPTA.DL_TYPETAUX2;
                _m_ARTFAMCOMPTA.DL_CODETAXE3 = _m_ARTCOMPTA.DL_CODETAXE3; _m_ARTFAMCOMPTA.DL_LIBTAXE3 = _m_ARTCOMPTA.DL_LIBTAXE3; _m_ARTFAMCOMPTA.DL_TAXE3 = _m_ARTCOMPTA.DL_TAXE3; _m_ARTFAMCOMPTA.DL_TYPETAXE3 = _m_ARTCOMPTA.DL_TYPETAXE3; _m_ARTFAMCOMPTA.DL_TYPETAUX3 = _m_ARTCOMPTA.DL_TYPETAUX3;
            }
        }
        else {
            let _m_FAMCOMPTA = _cItem.FAMCOMPTA_ITEMS.find(m=> m.N_CATCOMPTA == N_CATCOMPTA); // _cItem.COMPTET.N_CATCOMPTA
            if(_m_FAMCOMPTA) {
                if ((!_m_FAMCOMPTA.DL_CODETAXE1 && (_m_FAMCOMPTA.DL_CODETAXE2 || _m_FAMCOMPTA.DL_CODETAXE3)) || (!_m_FAMCOMPTA.DL_CODETAXE2 && (_m_FAMCOMPTA.DL_CODETAXE3))) { 
                    alert("Linkup ne traite pas correctement les cas où il y a des taxes 2 ou 3 sans taxe 1 et les cas avec une taxe 3 sans taxe 2. Veuillez vérifier la configuration comptable de l'article " + _pItem.AR_REF + " et corriger les éventuelles incohérences (il doit y avoir une taxe 1 si il y a une taxe 2 ou 3 et il doit y avoir une taxe 2 si il y a une taxe 3). Merci de votre compréhension." );
                }
                DL_TAXE1 = _m_FAMCOMPTA.DL_TAXE1!; DL_CODETAXE1 = _m_FAMCOMPTA.DL_CODETAXE1!; DL_TYPETAUX1 = _m_FAMCOMPTA.DL_TYPETAUX1!; DL_TYPETAXE1 = _m_FAMCOMPTA.DL_TYPETAXE1!;
                DL_TAXE2 = _m_FAMCOMPTA.DL_TAXE2!; DL_CODETAXE2 = _m_FAMCOMPTA.DL_CODETAXE2!; DL_TYPETAUX2 = _m_FAMCOMPTA.DL_TYPETAUX2!; DL_TYPETAXE2 = _m_FAMCOMPTA.DL_TYPETAXE2!;
                DL_TAXE3 = _m_FAMCOMPTA.DL_TAXE3!; DL_CODETAXE3 = _m_FAMCOMPTA.DL_CODETAXE3!; DL_TYPETAUX3 = _m_FAMCOMPTA.DL_TYPETAUX3!; DL_TYPETAXE3 = _m_FAMCOMPTA.DL_TYPETAXE3!;
                _m_ARTFAMCOMPTA = new CluArtFamComptaItem(); 
                _m_ARTFAMCOMPTA.N_CATCOMPTA = _m_FAMCOMPTA.N_CATCOMPTA;
                _m_ARTFAMCOMPTA.DL_CODETAXE1 = _m_FAMCOMPTA.DL_CODETAXE1; _m_ARTFAMCOMPTA.DL_LIBTAXE1 = _m_FAMCOMPTA.DL_LIBTAXE1; _m_ARTFAMCOMPTA.DL_TAXE1 = _m_FAMCOMPTA.DL_TAXE1; _m_ARTFAMCOMPTA.DL_TYPETAXE1 = _m_FAMCOMPTA.DL_TYPETAXE1; _m_ARTFAMCOMPTA.DL_TYPETAUX1 = _m_FAMCOMPTA.DL_TYPETAUX1;
                _m_ARTFAMCOMPTA.DL_CODETAXE2 = _m_FAMCOMPTA.DL_CODETAXE2; _m_ARTFAMCOMPTA.DL_LIBTAXE2 = _m_FAMCOMPTA.DL_LIBTAXE2; _m_ARTFAMCOMPTA.DL_TAXE2 = _m_FAMCOMPTA.DL_TAXE2; _m_ARTFAMCOMPTA.DL_TYPETAXE2 = _m_FAMCOMPTA.DL_TYPETAXE2; _m_ARTFAMCOMPTA.DL_TYPETAUX2 = _m_FAMCOMPTA.DL_TYPETAUX2;
                _m_ARTFAMCOMPTA.DL_CODETAXE3 = _m_FAMCOMPTA.DL_CODETAXE3; _m_ARTFAMCOMPTA.DL_LIBTAXE3 = _m_FAMCOMPTA.DL_LIBTAXE3; _m_ARTFAMCOMPTA.DL_TAXE3 = _m_FAMCOMPTA.DL_TAXE3; _m_ARTFAMCOMPTA.DL_TYPETAXE3 = _m_FAMCOMPTA.DL_TYPETAXE3; _m_ARTFAMCOMPTA.DL_TYPETAUX3 = _m_FAMCOMPTA.DL_TYPETAUX3;
            }
        }
        if(_gfPickedRes && !_gfPickedRes.CANCELED) { DL_PU = _gfPickedRes.DL_GF_C_TOTAL_TTC_INIT; }
        let DL_PRIXUNITAIRE = DL_TTC == 1 ? this.doConvertTTCtoHT(DL_PU, _pItem.AR_POIDSNET!, _m_ARTFAMCOMPTA) : DL_PU;
        let DL_PUTTC = DL_TTC == 1 ? DL_PU : this.doConvertHTtoTTC(DL_PU, _pItem.AR_POIDSNET!, _m_ARTFAMCOMPTA);

        let _docLigneItem : RxCluDocLigneDocumentType = {
            PK_ID : uuidv4(), 
            MD_SITEGID : this.ENTETE.MD_SITEGID,
            MD_SITE : this.ENTETE.MD_SITE,
            USER_ID : this.ENTETE.USER_ID,
            MD_DATE_CREATION : moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
            CBMARQ : this.LIGNES.length == 0 ? 1 : Math.max(...this.LIGNES.map(x=> x.MD_CBMARQ)) + 1,
            MD_CBMARQ : this.LIGNES.length == 0 ? 1 : Math.max(...this.LIGNES.map(x=> x.MD_CBMARQ)) + 1,
            DL_NO : 0,
            DO_PIECE : this.ENTETE.DO_PIECE,
            DO_PIECE_INTERNAL : this.ENTETE.DO_PIECE_INTERNAL,
            DL_LIGNE : this.LIGNES.length == 0 ? 1000 : Math.max(...this.LIGNES.map(x=> x.DL_LIGNE)) + 1000, 
            DE_NO : _lsItem ? _lsItem.DE_NO : this.ENTETE.DE_NO, 
            DE_INTITULE : _lsItem ? _lsItem.DE_INTITULE : this.ENTETE.DE_INTITULE,
            AR_REF : _pItem.AR_REF,
            FA_CODEFAMILLE : _pItem.FA_FAMNV1,
            AR_REFCOMPOSE : _pItem.AR_NOMENCLLIB.indexOf('COMMERCIALE') > -1 ? _pItem.AR_REF : '',
            DL_DESIGN : _pItem.AR_DESIGN,
            AG_NO1 : 0,
            AG_NO1LIB : '',
            AG_NO2 : 0,
            AG_NO2LIB : '',
            LS_NOSERIE : _lsItem ? _lsItem.LS_NOSERIE : '',
            LS_COMPLEMENT : _lsItem ? _lsItem.LS_COMPLEMENT : '',
            LS_PEREMPTION : _lsItem && _lsItem.LS_PEREMPTION ? _lsItem.LS_PEREMPTION.toISOString() : '',
            LS_FABRICATION : _lsItem && _lsItem.LS_FABRICATION ? _lsItem.LS_FABRICATION.toISOString() : '',
            LS_QTE : _lsItem && _lsItem.LS_QTE > 0 ? 1 : 0,
            DL_QTE : 1, 
            DL_POIDSNET : _pItem.AR_POIDSNET,
            DL_POIDSBRUT : _pItem.AR_POIDSBRUT,
            DL_PRIXUNITAIRE : DL_PRIXUNITAIRE, 
            DL_PRIXUNITAIRE_NC : DL_PRIXUNITAIRE, 
            DL_REMISE01REM_VALEUR : 0,
            DL_REMISE01REM_TYPE : 0,
            DL_REMISE02REM_VALEUR : 0,
            DL_REMISE02REM_TYPE : 0,
            DL_REMISE03REM_VALEUR : 0,
            DL_REMISE03REM_TYPE : 0,
            DL_REMISE_LIB : '',
            DL_TAXE1 : DL_TAXE1, 
            DL_CODETAXE1 : DL_CODETAXE1,
            DL_TYPETAUX1 : DL_TYPETAUX1,
            DL_TYPETAXE1 : DL_TYPETAXE1, 
            DL_TAXE2 : DL_TAXE2, 
            DL_CODETAXE2 : DL_CODETAXE2,
            DL_TYPETAUX2 : DL_TYPETAUX2,
            DL_TYPETAXE2 : DL_TYPETAXE2, 
            DL_TAXE3 : DL_TAXE3, 
            DL_CODETAXE3 : DL_CODETAXE3,
            DL_TYPETAUX3 : DL_TYPETAUX3,
            DL_TYPETAXE3 : DL_TYPETAXE3, 
            EU_QTE : 1, 
            EU_ENUMERE : _pItem.AR_UNITEVEN, 
            DL_TTC : DL_TTC, 
            DL_PUTTC : DL_PUTTC, 
            DL_PUTTC_NC : DL_PUTTC, 
            DL_MONTANTHT : DL_PRIXUNITAIRE, 
            DL_MONTANTTTC : DL_PUTTC, 
            DL_VALORISE : _pItem.AR_NOMENCLLIB == 'COMMERCIALE / COMPOSANT' ? 0 : 1, 
            DL_NOSOUSTOTAL : 0, 
            EST_SOUSTOTAL : false, 
            DL_LCREC :  _lcRParams && _lcRParams.LC_REC_GID ? 1 : 0, 
            DL_LCREC_DATE : _lcRParams && _lcRParams.LC_REC_GID ? moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z' : undefined,
            LC_REC_PTS_NB : _lcRParams && _lcRParams.LC_REC_PTS_NB ? _lcRParams.LC_REC_PTS_NB : 0,
            LC_PG_GID : _lcRParams && _lcRParams.LC_PG_GID ? _lcRParams.LC_PG_GID : undefined,
            LC_REC_GID : _lcRParams && _lcRParams.LC_REC_GID ? _lcRParams.LC_REC_GID : undefined,
            LC_REC_TYPE : _lcRParams && _lcRParams.LC_REC_TYPE ? _lcRParams.LC_REC_TYPE : 0,

            DL_GIFTCARD : _gfPickedRes && !_gfPickedRes.CANCELED,
            DL_GF_CARTE_NUM : _gfPickedRes && !_gfPickedRes.CANCELED ? _gfPickedRes.DL_GF_CARTE_NUM : undefined,
            DL_GF_CARTE_DESIGNATION : _gfPickedRes && !_gfPickedRes.CANCELED ? _gfPickedRes.DL_GF_CARTE_DESIGNATION : undefined,
            DL_GF_C_TOTAL_TTC_INIT : _gfPickedRes && !_gfPickedRes.CANCELED ? _gfPickedRes.DL_GF_C_TOTAL_TTC_INIT : 0,
            DL_GF_DATE_DEBUT : _gfPickedRes && !_gfPickedRes.CANCELED ? _gfPickedRes.DL_GF_DATE_DEBUT.toISOString() : undefined,
            DL_GF_DATE_EXP : _gfPickedRes && !_gfPickedRes.CANCELED ? _gfPickedRes.DL_GF_DATE_EXP.toISOString() : undefined, 
            
            DL_ESCOMPTE : 0, 

            Z_CHECKED : true
        };
        if(_lsItem && _lsItem.LS_NOSERIE && _lsItem.LS_QTE) {
            _docLigneItem.DL_POIDSNET = _docLigneItem.DL_QTE == 0 ? 0 : (_docLigneItem.DL_POIDSNET! / _docLigneItem.DL_QTE!) * _lsItem.LS_QTE;
            _docLigneItem.DL_POIDSBRUT = _docLigneItem.DL_QTE == 0 ? 0 : (_docLigneItem.DL_POIDSBRUT! / _docLigneItem.DL_QTE!) * _lsItem.LS_QTE;
            _docLigneItem.LS_QTE = _lsItem.LS_QTE;
            _docLigneItem.DL_QTE = _lsItem.LS_QTE;
            _docLigneItem.EU_QTE = _lsItem.LS_QTE;
            _docLigneItem.DL_MONTANTHT = _docLigneItem.DL_QTE * _docLigneItem.DL_PRIXUNITAIRE;
            _docLigneItem.DL_MONTANTTTC = _docLigneItem.DL_QTE * _docLigneItem.DL_PUTTC!; 
        }
        if(_docLigneItem.DL_VALORISE == 0) { _docLigneItem.DL_LCREC = 0; _docLigneItem.DL_LCREC_DATE = undefined; _docLigneItem.LC_REC_PTS_NB = 0; _docLigneItem.LC_PG_GID = undefined;  _docLigneItem.LC_REC_GID = undefined; _docLigneItem.LC_REC_TYPE = undefined; }
        if(_nItem){
            if(_nItem.REF_ARTICLE_ARTGAMME != undefined){
                _docLigneItem.AG_NO1 = _nItem.REF_ARTICLE_ARTGAMME.AG_NO1;
                _docLigneItem.AG_NO1LIB = _nItem.REF_ARTICLE_ARTGAMME.AG_NO1LIB;
                _docLigneItem.AG_NO2 = _nItem.REF_ARTICLE_ARTGAMME.AG_NO2;
                _docLigneItem.AG_NO2LIB = _nItem.REF_ARTICLE_ARTGAMME.AG_NO2LIB;
            }
            if(_nItem.PARENT_ARTICLE){
                switch(_nItem.PARENT_ARTICLE.AR_NOMENCLLIB) {
                    case 'COMMERCIALE / COMPOSANT' : 
                        _docLigneItem.AR_REFCOMPOSE = _nItem.PARENT_ARTICLE.AR_REF;
                        _docLigneItem.DL_VALORISE = _nItem.PARENT_ARTICLE.AR_REF == _pItem.AR_REF ? 0 : 1;
                        break;
                    case 'COMMERCIALE / COMPOSE' : 
                        _docLigneItem.AR_REFCOMPOSE = _nItem.PARENT_ARTICLE.AR_REF;
                        _docLigneItem.DL_VALORISE = _nItem.PARENT_ARTICLE.AR_REF == _pItem.AR_REF ? 1 : 0;
                        break;
                }
            }
            if(_nItem.NOMENCLATURE) {
                _docLigneItem.DL_POIDSNET = _docLigneItem.DL_QTE == 0 ? 0 : (_docLigneItem.DL_POIDSNET! / _docLigneItem.DL_QTE!) * _nItem.NOMENCLATURE.NO_QTE;
                _docLigneItem.DL_POIDSBRUT = _docLigneItem.DL_QTE == 0 ? 0 : (_docLigneItem.DL_POIDSBRUT! / _docLigneItem.DL_QTE!) * _nItem.NOMENCLATURE.NO_QTE;
                _docLigneItem.DL_QTE = _nItem.NOMENCLATURE.NO_QTE;
                _docLigneItem.EU_QTE = _nItem.NOMENCLATURE.NO_QTE;
                _docLigneItem.DL_MONTANTHT = _docLigneItem.DL_QTE * _docLigneItem.DL_PRIXUNITAIRE;
                _docLigneItem.DL_MONTANTTTC = _docLigneItem.DL_QTE * _docLigneItem.DL_PUTTC!; 
            }
        }
        // #region CONDITIONNEMENT PRINCIPAL ? 
        // EXCLUSION DES CAS AVEC NOMENCLATURE VIA !_nItem
        if(!_nItem && _pItem.AR_CONDITION > 0 && _cItem.CONDITION_ITEMS.length > 0){
            let COND_PRINCIPAL = _cItem.CONDITION_ITEMS.find(m=> m.CO_PRINCIPAL == 1);
            if(COND_PRINCIPAL != null) {
                _docLigneItem.DL_POIDSNET = _docLigneItem.DL_QTE == 0 ? 0 : (_docLigneItem.DL_POIDSNET! / _docLigneItem.DL_QTE!) * COND_PRINCIPAL.EC_QUANTITE;
                _docLigneItem.DL_POIDSBRUT = _docLigneItem.DL_QTE == 0 ? 0 : (_docLigneItem.DL_POIDSBRUT! / _docLigneItem.DL_QTE!) * COND_PRINCIPAL.EC_QUANTITE;
                _docLigneItem.EU_QTE = 1;
                _docLigneItem.EU_ENUMERE = COND_PRINCIPAL.EC_ENUMERE;
                _docLigneItem.DL_QTE = COND_PRINCIPAL.EC_QUANTITE;
                _docLigneItem.DL_MONTANTHT = _docLigneItem.DL_QTE * _docLigneItem.DL_PRIXUNITAIRE;
                _docLigneItem.DL_MONTANTTTC = _docLigneItem.DL_QTE * _docLigneItem.DL_PUTTC!; 

                // SPECIFICITE TARIFAIRE POUR UN COND PARTICULIER
                let TARIFCOND_ITEM = _cItem.TARIFCOND_ITEMS.find(m=> m.CO_NO == COND_PRINCIPAL!.CO_NO);
                if(TARIFCOND_ITEM != null){
                    let _format = sessionStorage.getItem('CAURIS_LINKUP_FORMAT') || '';
                    let _pipe = new CustomNumberPipe();
                    let _nbDecimales = _pipe.recupererNombreDecimales(_format);
                    if(_docLigneItem.DL_TTC == 1){
                        _docLigneItem.DL_MONTANTTTC = _docLigneItem.EU_QTE * TARIFCOND_ITEM.TC_PRIX;
                        _docLigneItem.DL_MONTANTHT = this.doConvertTTCtoHT(_docLigneItem.DL_MONTANTTTC, _docLigneItem.DL_POIDSNET!, _m_ARTFAMCOMPTA);
                        _docLigneItem.DL_PUTTC = this.doRound(_docLigneItem.DL_MONTANTTTC / _docLigneItem.DL_QTE, _nbDecimales);
                        _docLigneItem.DL_PRIXUNITAIRE = this.doRound(_docLigneItem.DL_MONTANTHT / _docLigneItem.DL_QTE, _nbDecimales);
                    }
                    else {
                        _docLigneItem.DL_MONTANTHT = _docLigneItem.EU_QTE * TARIFCOND_ITEM.TC_PRIX;
                        _docLigneItem.DL_MONTANTTTC = this.doConvertHTtoTTC(_docLigneItem.DL_MONTANTHT, _docLigneItem.DL_POIDSNET!, _m_ARTFAMCOMPTA);
                        _docLigneItem.DL_PUTTC = this.doRound(_docLigneItem.DL_MONTANTTTC / _docLigneItem.DL_QTE, _nbDecimales);
                        _docLigneItem.DL_PRIXUNITAIRE = this.doRound(_docLigneItem.DL_MONTANTHT / _docLigneItem.DL_QTE, _nbDecimales);
                    }
                }
            }
        }
        // #endregion

        // #region DL_QTE Input
        if(DL_QTE && DL_QTE > 0) {
            if(_pItem.AR_SUIVISTOCKLIB && _pItem.AR_SUIVISTOCKLIB!.indexOf('SERI') > - 1) { }
            else if (_pItem.AR_SUIVISTOCKLIB && _pItem.AR_SUIVISTOCKLIB!.indexOf('PAR LOT') > - 1) { }
            else {
                _docLigneItem.DL_POIDSNET = _docLigneItem.DL_QTE == 0 ? 0 : (_docLigneItem.DL_POIDSNET! / _docLigneItem.DL_QTE!) * DL_QTE * _docLigneItem.DL_QTE;
                _docLigneItem.DL_POIDSBRUT = _docLigneItem.DL_QTE == 0 ? 0 : (_docLigneItem.DL_POIDSBRUT! / _docLigneItem.DL_QTE!) * DL_QTE * _docLigneItem.DL_QTE;
                _docLigneItem.DL_QTE = DL_QTE * _docLigneItem.DL_QTE;
                _docLigneItem.EU_QTE = DL_QTE * _docLigneItem.EU_QTE!;
                this.DL_RECALCUL_TOTAUX_LIGNES(_docLigneItem);
            }
        }
        // #endregion
        
        let DEF_REMISES_PARAMS = this.GET_DEFAULT_REMISES_PARAMS(_cItem);
        DEF_REMISES_PARAMS.REM_CONFLICT_MODE = this.ENTETE.DO_REM_CONFLICT_MODE!;
        if(DEF_REMISES_PARAMS.SPECREM_FOUND) { this.APPLY_DEFAULT_REMISES(_docLigneItem, DEF_REMISES_PARAMS); }

        this.APPLY_PROMO_REMISES(_docLigneItem, _cItem);
        this.APPLY_NOMENCLATURE_PREPARTITION_REMISES(_docLigneItem, _nItem);

        _docLigneItem.DL_PRIXUNITAIRE_NET = _docLigneItem.DL_QTE == 0 ? 0 : _docLigneItem.DL_MONTANTHT / _docLigneItem.DL_QTE;
        _docLigneItem.DL_PUTTC_NET = _docLigneItem.DL_QTE == 0 ? 0 : _docLigneItem.DL_MONTANTTTC / _docLigneItem.DL_QTE;
        return _docLigneItem;
    }

    private doConvertTTCtoHT(DL_PU_TTC : number, DL_POIDSNET : number, _acpItem : CluArtFamComptaItem | undefined) : number {
        if(_acpItem == undefined) return DL_PU_TTC;
        // #region TAXES
        /**
         * DL_TYPETAXE
         * 0 à 4 
         * 0 = TVA/débit 
         * 1 = TVA/Encaissement 
         * 2 = TP/HT 
         * 3 = TP/TTC 
         * 4 = TP/Poids
         * 5 = TVA/CEE
         * 6 = Surtaxe
         */
        /**
         * DL_TYPETAUX
         * 0 à 2
         * 0 = Taux % 
         * 1 = Montant F
         * 2 = Quantité U
         */
        // #endregion
        let HAS_ERROR : boolean = false;
        let NB_TAXES : number = 0;
        if(_acpItem.DL_CODETAXE3 && _acpItem.DL_TAXE3 != undefined && _acpItem.DL_TAXE3 != 0) { NB_TAXES++;
            //if(_acpItem.DL_TYPETAXE3 == 4) { let _message = 'DL_TYPETAXE3 : 4 [TP/Poids] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAXE3 == 5) { let _message = 'DL_TYPETAXE3 : 5 [TVA/CEE] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAXE3 == 6) { let _message = 'DL_TYPETAXE3 : 6 [Surtaxe] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAUX3 != 0) { let _message = 'DL_TYPETAUX3 : <> 0 [Taux %] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
        }
        if(_acpItem.DL_CODETAXE2 && _acpItem.DL_TAXE2 != undefined && _acpItem.DL_TAXE2 != 0) { NB_TAXES++;
            //if(_acpItem.DL_TYPETAXE2 == 4) { let _message = 'DL_TYPETAXE2 : 4 [TP/Poids] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAXE2 == 5) { let _message = 'DL_TYPETAXE2 : 5 [TVA/CEE] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAXE2 == 6) { let _message = 'DL_TYPETAXE2 : 6 [Surtaxe] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAUX2 != 0) { let _message = 'DL_TYPETAUX2 : <> 0 [Taux %] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
        }
        if(_acpItem.DL_CODETAXE1 && _acpItem.DL_TAXE1 != undefined && _acpItem.DL_TAXE1 != 0) { NB_TAXES++;
            //if(_acpItem.DL_TYPETAXE1 == 4) { let _message = 'DL_TYPETAXE1 : 4 [TP/Poids] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAXE1 == 5) { let _message = 'DL_TYPETAXE1 : 5 [TVA/CEE] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAXE1 == 6) { let _message = 'DL_TYPETAXE1 : 6 [Surtaxe] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAUX1 != 0) { let _message = 'DL_TYPETAUX1 : <> 0 [Taux %] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
        }
        if (NB_TAXES == 0) return DL_PU_TTC;
        let _acpItemF : CluArtFamComptaItem = JSON.parse(JSON.stringify(_acpItem));
        if ((!_acpItem.DL_CODETAXE1 && (_acpItem.DL_CODETAXE2 || _acpItem.DL_CODETAXE3)) || (!_acpItem.DL_CODETAXE2 && (_acpItem.DL_CODETAXE3))) { 
            const taxes = [
                { code: _acpItem.DL_CODETAXE1, taxe: _acpItem.DL_TAXE1, typeTaxe: _acpItem.DL_TYPETAXE1, typeTaux: _acpItem.DL_TYPETAUX1 },
                { code: _acpItem.DL_CODETAXE2, taxe: _acpItem.DL_TAXE2, typeTaxe: _acpItem.DL_TYPETAXE2, typeTaux: _acpItem.DL_TYPETAUX2 },
                { code: _acpItem.DL_CODETAXE3, taxe: _acpItem.DL_TAXE3, typeTaxe: _acpItem.DL_TYPETAXE3, typeTaux: _acpItem.DL_TYPETAUX3 }
            ].filter(t => !!t.code);

            while (taxes.length < 3) {
                taxes.push({ code: '', taxe: 0, typeTaxe: 0, typeTaux: 0 });
            }
            _acpItemF.DL_CODETAXE1 = taxes[0].code; _acpItemF.DL_TAXE1 = taxes[0].taxe; _acpItemF.DL_TYPETAXE1 = taxes[0].typeTaxe; _acpItemF.DL_TYPETAUX1 = taxes[0].typeTaux;
            _acpItemF.DL_CODETAXE2 = taxes[1].code; _acpItemF.DL_TAXE2 = taxes[1].taxe; _acpItemF.DL_TYPETAXE2 = taxes[1].typeTaxe; _acpItemF.DL_TYPETAUX2 = taxes[1].typeTaux;
            _acpItemF.DL_CODETAXE3 = taxes[2].code; _acpItemF.DL_TAXE3 = taxes[2].taxe; _acpItemF.DL_TYPETAXE3 = taxes[2].typeTaxe; _acpItemF.DL_TYPETAUX3 = taxes[2].typeTaux;
        }
        let TOTAL_TAXES = 0;
        if(!HAS_ERROR){
            switch(NB_TAXES){
                case 1 : 
                    {
                        if(_acpItemF.DL_TYPETAXE1 == 4) { TOTAL_TAXES = DL_PU_TTC - (DL_POIDSNET * (_acpItemF.DL_TAXE1! / 100.0000000)); }
                        else { TOTAL_TAXES = DL_PU_TTC / (1 + _acpItemF.DL_TAXE1! / 100.0000000); }
                        break;
                    }
                case 2 : 
                    {
                        let TAXES_T0T1 : any[] = []; let TAXES_T2 : any[] = []; let TAXES_T3 : any[] = []; let TAXES_T4 : any[] = []; let TAXES_OTHERS : any[] = [];
                        if([0,1].indexOf(_acpItemF.DL_TYPETAXE1!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE1, DL_TAXE : _acpItemF.DL_TAXE1 }); } 
                        else if ([2].indexOf(_acpItemF.DL_TYPETAXE1!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE1, DL_TAXE : _acpItemF.DL_TAXE1 }); } 
                        else if ([3].indexOf(_acpItemF.DL_TYPETAXE1!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE1, DL_TAXE : _acpItemF.DL_TAXE1 }); } 
                        else if ([4].indexOf(_acpItemF.DL_TYPETAXE1!) > -1) { TAXES_T4.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE1, DL_TAXE : _acpItemF.DL_TAXE1 }); } 
                        else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE1, DL_TAXE : _acpItemF.DL_TAXE1 }); }

                        if([0,1].indexOf(_acpItemF.DL_TYPETAXE2!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE2, DL_TAXE : _acpItemF.DL_TAXE2 }); } 
                        else if ([2].indexOf(_acpItemF.DL_TYPETAXE2!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE2, DL_TAXE : _acpItemF.DL_TAXE2 }); } 
                        else if ([3].indexOf(_acpItemF.DL_TYPETAXE2!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE2, DL_TAXE : _acpItemF.DL_TAXE2 }); } 
                        else if ([4].indexOf(_acpItemF.DL_TYPETAXE2!) > -1) { TAXES_T4.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE2, DL_TAXE : _acpItemF.DL_TAXE2 }); } 
                        else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE2, DL_TAXE : _acpItemF.DL_TAXE2 }); }  

                        if(TAXES_T4.length > 0) { DL_PU_TTC = DL_PU_TTC - (DL_POIDSNET * (TAXES_T4.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000)); }

                        TOTAL_TAXES = DL_PU_TTC / 
                                      (1 + TAXES_T0T1.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) / 
                                      (1 + TAXES_T2.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) / 
                                      (1 + TAXES_T3.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) / 
                                      (1 + TAXES_OTHERS.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000);
                        break;
                    }
                case 3 : 
                    {
                        let TAXES_T0T1 : any[] = []; let TAXES_T2 : any[] = []; let TAXES_T3 : any[] = []; let TAXES_T4 : any[] = []; let TAXES_OTHERS : any[] = [];
                        if([0,1].indexOf(_acpItemF.DL_TYPETAXE1!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE1, DL_TAXE : _acpItemF.DL_TAXE1 }); } 
                        else if ([2].indexOf(_acpItemF.DL_TYPETAXE1!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE1, DL_TAXE : _acpItemF.DL_TAXE1 }); } 
                        else if ([3].indexOf(_acpItemF.DL_TYPETAXE1!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE1, DL_TAXE : _acpItemF.DL_TAXE1 }); } 
                        else if ([4].indexOf(_acpItemF.DL_TYPETAXE1!) > -1) { TAXES_T4.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE1, DL_TAXE : _acpItemF.DL_TAXE1 }); } 
                        else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE1, DL_TAXE : _acpItemF.DL_TAXE1 }); }

                        if([0,1].indexOf(_acpItemF.DL_TYPETAXE2!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE2, DL_TAXE : _acpItemF.DL_TAXE2 }); } 
                        else if ([2].indexOf(_acpItemF.DL_TYPETAXE2!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE2, DL_TAXE : _acpItemF.DL_TAXE2 }); } 
                        else if ([3].indexOf(_acpItemF.DL_TYPETAXE2!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE2, DL_TAXE : _acpItemF.DL_TAXE2 }); } 
                        else if ([4].indexOf(_acpItemF.DL_TYPETAXE2!) > -1) { TAXES_T4.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE2, DL_TAXE : _acpItemF.DL_TAXE2 }); } 
                        else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE2, DL_TAXE : _acpItemF.DL_TAXE2 }); }  

                        if([0,1].indexOf(_acpItemF.DL_TYPETAXE3!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE3, DL_TAXE : _acpItemF.DL_TAXE3 }); } 
                        else if ([2].indexOf(_acpItemF.DL_TYPETAXE3!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE3, DL_TAXE : _acpItemF.DL_TAXE3 }); } 
                        else if ([3].indexOf(_acpItemF.DL_TYPETAXE3!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE3, DL_TAXE : _acpItemF.DL_TAXE3 }); } 
                        else if ([4].indexOf(_acpItemF.DL_TYPETAXE3!) > -1) { TAXES_T4.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE3, DL_TAXE : _acpItemF.DL_TAXE3 }); } 
                        else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE3, DL_TAXE : _acpItemF.DL_TAXE3 }); }  

                        if(TAXES_T4.length > 0) { DL_PU_TTC = DL_PU_TTC - (DL_POIDSNET * (TAXES_T4.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000)); }

                        TOTAL_TAXES = DL_PU_TTC / 
                                      (1 + TAXES_T0T1.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) / 
                                      (1 + TAXES_T2.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) / 
                                      (1 + TAXES_T3.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) / 
                                      (1 + TAXES_OTHERS.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000);
                        break;
                    }
            }
        }
        let _format = sessionStorage.getItem('CAURIS_LINKUP_FORMAT') || '';
        let _pipe = new CustomNumberPipe();
        let _nbDecimales = _pipe.recupererNombreDecimales(_format);
        let RESULT = this.doRound(TOTAL_TAXES, _nbDecimales);
        return RESULT;
    } 

    private doConvertHTtoTTC(DL_PU_HT : number, DL_POIDSNET : number, _acpItem : CluArtFamComptaItem | undefined) : number {
        if(_acpItem == undefined) return DL_PU_HT;
        // #region TAXES
        /**
         * DL_TYPETAXE
         * 0 à 4 
         * 0 = TVA/débit 
         * 1 = TVA/Encaissement 
         * 2 = TP/HT 
         * 3 = TP/TTC 
         * 4 = TP/Poids
         * 5 = TVA/CEE
         * 6 = Surtaxe
         */
        /**
         * DL_TYPETAUX
         * 0 à 2
         * 0 = Taux % 
         * 1 = Montant F
         *  2 = Quantité U
         */
        // #endregion
        let HAS_ERROR : boolean = false;
        let NB_TAXES = 0;
        if(_acpItem.DL_CODETAXE1 && _acpItem.DL_TAXE1 != undefined && _acpItem.DL_TAXE1 != 0) { NB_TAXES++;
            //if(_acpItem.DL_TYPETAXE1 == 4) { let _message = 'DL_TYPETAXE1 : 4 [TP/Poids] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAXE1 == 5) { let _message = 'DL_TYPETAXE1 : 5 [TVA/CEE] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAXE1 == 6) { let _message = 'DL_TYPETAXE1 : 6 [Surtaxe] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAUX1 != 0) { let _message = 'DL_TYPETAUX1 : <> 0 [Taux %] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
        }
        if(_acpItem.DL_CODETAXE2 && _acpItem.DL_TAXE2 != undefined && _acpItem.DL_TAXE2 != 0) { NB_TAXES++;
            //if(_acpItem.DL_TYPETAXE2 == 4) { let _message = 'DL_TYPETAXE2 : 4 [TP/Poids] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAXE2 == 5) { let _message = 'DL_TYPETAXE2 : 5 [TVA/CEE] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAXE2 == 6) { let _message = 'DL_TYPETAXE2 : 6 [Surtaxe] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAUX2 != 0) { let _message = 'DL_TYPETAUX2 : <> 0 [Taux %] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
        }
        if(_acpItem.DL_CODETAXE3 && _acpItem.DL_TAXE3 != undefined && _acpItem.DL_TAXE3 != 0) { NB_TAXES++;
            //if(_acpItem.DL_TYPETAXE3 == 4) { let _message = 'DL_TYPETAXE3 : 4 [TP/Poids] : Not Implemented Exception'; alert(_message); console.log(_message); }
            if(_acpItem.DL_TYPETAXE3 == 5) { let _message = 'DL_TYPETAXE3 : 5 [TVA/CEE] : Not Implemented Exception'; alert(_message); console.log(_message); }
            if(_acpItem.DL_TYPETAXE3 == 6) { let _message = 'DL_TYPETAXE3 : 6 [Surtaxe] : Not Implemented Exception'; alert(_message); console.log(_message); }
            if(_acpItem.DL_TYPETAUX3 != 0) { let _message = 'DL_TYPETAUX3 : <> 0 [Taux %] : Not Implemented Exception'; alert(_message); console.log(_message); }
        }
        if(NB_TAXES == 0) return DL_PU_HT;
        let _acpItemF : CluArtFamComptaItem = JSON.parse(JSON.stringify(_acpItem));
        if ((!_acpItem.DL_CODETAXE1 && (_acpItem.DL_CODETAXE2 || _acpItem.DL_CODETAXE3)) || (!_acpItem.DL_CODETAXE2 && (_acpItem.DL_CODETAXE3))) { 
            const taxes = [
                { code: _acpItem.DL_CODETAXE1, taxe: _acpItem.DL_TAXE1, typeTaxe: _acpItem.DL_TYPETAXE1, typeTaux: _acpItem.DL_TYPETAUX1 },
                { code: _acpItem.DL_CODETAXE2, taxe: _acpItem.DL_TAXE2, typeTaxe: _acpItem.DL_TYPETAXE2, typeTaux: _acpItem.DL_TYPETAUX2 },
                { code: _acpItem.DL_CODETAXE3, taxe: _acpItem.DL_TAXE3, typeTaxe: _acpItem.DL_TYPETAXE3, typeTaux: _acpItem.DL_TYPETAUX3 }
            ].filter(t => !!t.code);

            while (taxes.length < 3) {
                taxes.push({ code: '', taxe: 0, typeTaxe: 0, typeTaux: 0 });
            }
            _acpItemF.DL_CODETAXE1 = taxes[0].code; _acpItemF.DL_TAXE1 = taxes[0].taxe; _acpItemF.DL_TYPETAXE1 = taxes[0].typeTaxe; _acpItemF.DL_TYPETAUX1 = taxes[0].typeTaux;
            _acpItemF.DL_CODETAXE2 = taxes[1].code; _acpItemF.DL_TAXE2 = taxes[1].taxe; _acpItemF.DL_TYPETAXE2 = taxes[1].typeTaxe; _acpItemF.DL_TYPETAUX2 = taxes[1].typeTaux;
            _acpItemF.DL_CODETAXE3 = taxes[2].code; _acpItemF.DL_TAXE3 = taxes[2].taxe; _acpItemF.DL_TYPETAXE3 = taxes[2].typeTaxe; _acpItemF.DL_TYPETAUX3 = taxes[2].typeTaux;
        }
        let TOTAL_TAXES : number = 0;
        if(!HAS_ERROR){
            switch(NB_TAXES){
                case 1:
                {
                    if(_acpItemF.DL_TYPETAXE1 == 4) { TOTAL_TAXES = DL_PU_HT + DL_POIDSNET * (_acpItemF.DL_TAXE1! / 100.0000000); }
                    else { TOTAL_TAXES = DL_PU_HT * (1 + _acpItemF.DL_TAXE1! / 100.0000000); }
                    break;
                }
                case 2: 
                {
                    let TAXES_T0T1 : any[] = []; let TAXES_T2 : any[] = []; let TAXES_T3 : any[] = []; let TAXES_T4 : any[] = []; let TAXES_OTHERS : any[] = [];
                    if([0,1].indexOf(_acpItemF.DL_TYPETAXE1!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE1, DL_TAXE : _acpItemF.DL_TAXE1 }); } 
                    else if ([2].indexOf(_acpItemF.DL_TYPETAXE1!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE1, DL_TAXE : _acpItemF.DL_TAXE1 }); } 
                    else if ([3].indexOf(_acpItemF.DL_TYPETAXE1!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE1, DL_TAXE : _acpItemF.DL_TAXE1 }); } 
                    else if ([4].indexOf(_acpItemF.DL_TYPETAXE1!) > -1) { TAXES_T4.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE1, DL_TAXE : _acpItemF.DL_TAXE1 }); } 
                    else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE1, DL_TAXE : _acpItemF.DL_TAXE1 }); }

                    if([0,1].indexOf(_acpItemF.DL_TYPETAXE2!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE2, DL_TAXE : _acpItemF.DL_TAXE2 }); } 
                    else if ([2].indexOf(_acpItemF.DL_TYPETAXE2!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE2, DL_TAXE : _acpItemF.DL_TAXE2 }); } 
                    else if ([3].indexOf(_acpItemF.DL_TYPETAXE2!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE2, DL_TAXE : _acpItemF.DL_TAXE2 }); } 
                    else if ([4].indexOf(_acpItemF.DL_TYPETAXE2!) > -1) { TAXES_T4.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE2, DL_TAXE : _acpItemF.DL_TAXE2 }); } 
                    else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE2, DL_TAXE : _acpItemF.DL_TAXE2 }); }  
                    
                    TOTAL_TAXES = DL_PU_HT * 
                                      (1 + TAXES_T0T1.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) * 
                                      (1 + TAXES_T2.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) * 
                                      (1 + TAXES_T3.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) * 
                                      (1 + TAXES_OTHERS.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000);
                    if(TAXES_T4.length > 0) { TOTAL_TAXES = TOTAL_TAXES + DL_POIDSNET * (1 + TAXES_T4.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000); }
                    break;
                }
                case 3: 
                {
                    let TAXES_T0T1 : any[] = []; let TAXES_T2 : any[] = []; let TAXES_T3 : any[] = []; let TAXES_T4 : any[] = []; let TAXES_OTHERS : any[] = [];
                    if([0,1].indexOf(_acpItemF.DL_TYPETAXE1!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE1, DL_TAXE : _acpItemF.DL_TAXE1 }); } 
                    else if ([2].indexOf(_acpItemF.DL_TYPETAXE1!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE1, DL_TAXE : _acpItemF.DL_TAXE1 }); } 
                    else if ([3].indexOf(_acpItemF.DL_TYPETAXE1!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE1, DL_TAXE : _acpItemF.DL_TAXE1 }); } 
                    else if ([4].indexOf(_acpItemF.DL_TYPETAXE1!) > -1) { TAXES_T4.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE1, DL_TAXE : _acpItemF.DL_TAXE1 }); } 
                    else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE1, DL_TAXE : _acpItemF.DL_TAXE1 }); }

                    if([0,1].indexOf(_acpItemF.DL_TYPETAXE2!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE2, DL_TAXE : _acpItemF.DL_TAXE2 }); } 
                    else if ([2].indexOf(_acpItemF.DL_TYPETAXE2!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE2, DL_TAXE : _acpItemF.DL_TAXE2 }); } 
                    else if ([3].indexOf(_acpItemF.DL_TYPETAXE2!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE2, DL_TAXE : _acpItemF.DL_TAXE2 }); } 
                    else if ([4].indexOf(_acpItemF.DL_TYPETAXE2!) > -1) { TAXES_T4.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE2, DL_TAXE : _acpItemF.DL_TAXE2 }); } 
                    else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE2, DL_TAXE : _acpItemF.DL_TAXE2 }); }  

                    if([0,1].indexOf(_acpItemF.DL_TYPETAXE3!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE3, DL_TAXE : _acpItemF.DL_TAXE3 }); } 
                    else if ([2].indexOf(_acpItemF.DL_TYPETAXE3!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE3, DL_TAXE : _acpItemF.DL_TAXE3 }); } 
                    else if ([3].indexOf(_acpItemF.DL_TYPETAXE3!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE3, DL_TAXE : _acpItemF.DL_TAXE3 }); } 
                    else if ([4].indexOf(_acpItemF.DL_TYPETAXE3!) > -1) { TAXES_T4.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE3, DL_TAXE : _acpItemF.DL_TAXE3 }); } 
                    else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItemF.DL_TYPETAXE3, DL_TAXE : _acpItem.DL_TAXE3 }); }  

                    TOTAL_TAXES = DL_PU_HT * 
                                      (1 + TAXES_T0T1.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) * 
                                      (1 + TAXES_T2.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) * 
                                      (1 + TAXES_T3.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) * 
                                      (1 + TAXES_OTHERS.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000);
                    if(TAXES_T4.length > 0) { TOTAL_TAXES = TOTAL_TAXES + DL_POIDSNET * (1 + TAXES_T4.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000); }
                    break;
                }
            }
        }
        let _format = sessionStorage.getItem('CAURIS_LINKUP_FORMAT') || '';
        let _pipe = new CustomNumberPipe();
        let _nbDecimales = _pipe.recupererNombreDecimales(_format);
        let RESULT = this.doRound(TOTAL_TAXES, _nbDecimales);
        return RESULT;
    }
    // #endregion

    // #region HELPER ESCOMPTE & VALFRAIS
    SET_LIGNEREF_VALFRAIS(_cItem : CluDocContextItem) { 
        if(!_cItem.ARTICLE) return;
        this.LIGNEREF_VALFRAIS = this.GENERATE_LIGNE_HELPER_FN(_cItem.ARTICLE, _cItem, undefined, undefined, undefined, undefined, 1); 
        this.LIGNEREF_VALFRAIS.DL_DESIGN = 'CLU_VALFRAIS'; this.LIGNEREF_VALFRAIS.DL_PRIXUNITAIRE = 0; this.LIGNEREF_VALFRAIS.DL_PUTTC = 0; this.DL_RECALCUL_TOTAUX_LIGNES(this.LIGNEREF_VALFRAIS);
        this.LIGNEREF_VALFRAIS.DL_REMISE01REM_VALEUR = 0; this.LIGNEREF_VALFRAIS.DL_REMISE02REM_VALEUR = 0; this.LIGNEREF_VALFRAIS.DL_REMISE03REM_VALEUR = 0;
        this.DL_RECALCUL_LIGNEREF_VALFRAIS();
    }

    DL_RECALCUL_LIGNEREF_VALFRAIS() : RxCluDocLigneDocumentType { 
        if(this.ENTETE.DO_VALFRAIS && this.ENTETE.DO_VALFRAIS != 0 && !this.LIGNEREF_VALFRAIS) throw new Error('Paramétrage de la ligne de frais non définie dans le document');
        let _m_ARTFAMCOMPTA : CluArtFamComptaItem = new CluArtFamComptaItem(); 
        _m_ARTFAMCOMPTA.DL_CODETAXE1 = this.ENTETE.DO_CODETAXE1; _m_ARTFAMCOMPTA.DL_TAXE1 = this.ENTETE.DO_TAXE1; _m_ARTFAMCOMPTA.DL_TYPETAXE1 = this.ENTETE.DO_TYPETAXE1; _m_ARTFAMCOMPTA.DL_TYPETAUX1 = this.ENTETE.DO_TYPETAUX1;
        _m_ARTFAMCOMPTA.DL_CODETAXE2 = this.ENTETE.DO_CODETAXE2; _m_ARTFAMCOMPTA.DL_TAXE2 = this.ENTETE.DO_TAXE2; _m_ARTFAMCOMPTA.DL_TYPETAXE2 = this.ENTETE.DO_TYPETAXE2; _m_ARTFAMCOMPTA.DL_TYPETAUX2 = this.ENTETE.DO_TYPETAUX2;
        _m_ARTFAMCOMPTA.DL_CODETAXE3 = this.ENTETE.DO_CODETAXE3; _m_ARTFAMCOMPTA.DL_TAXE3 = this.ENTETE.DO_TAXE3; _m_ARTFAMCOMPTA.DL_TYPETAXE3 = this.ENTETE.DO_TYPETAXE3; _m_ARTFAMCOMPTA.DL_TYPETAUX3 = this.ENTETE.DO_TYPETAUX3;
        if(this.ENTETE.DO_TYPELIGNEFRAIS == 0) {
            this.LIGNEREF_VALFRAIS!.DL_PRIXUNITAIRE = this.ENTETE.DO_VALFRAIS!;
            this.LIGNEREF_VALFRAIS!.DL_PUTTC = this.doConvertHTtoTTC(this.ENTETE.DO_VALFRAIS!, 0, _m_ARTFAMCOMPTA);
        }
        else if(this.ENTETE.DO_TYPELIGNEFRAIS == 1) {
            this.LIGNEREF_VALFRAIS!.DL_PUTTC = this.ENTETE.DO_VALFRAIS!;
            this.LIGNEREF_VALFRAIS!.DL_PRIXUNITAIRE = this.doConvertTTCtoHT(this.ENTETE.DO_VALFRAIS!, 0, _m_ARTFAMCOMPTA);
        }
        this.DL_RECALCUL_TOTAUX_LIGNES(this.LIGNEREF_VALFRAIS!);
        return this.LIGNEREF_VALFRAIS!;
    }
    // #endregion 

    // #region DEFAULT REMISES
    GET_DEFAULT_REMISES_PARAMS(_cItem : CluDocContextItem) : CluDefaultRemisesResult {
        let _domaine = this.doGetDomaineFromDocumentTypeUtils_RemDocs(this.ENTETE.DO_TYPE!);
        let DEFAULT_REMISES_PARAMS = new CluDefaultRemisesResult();
        if(_domaine > 1) return new CluDefaultRemisesResult();
        /*
            TYPEREM : 
            0 : SIMPLE
            1 : HORS_REMISE

            QTEMONT :
            0 : SIMPLE & HORS_REMISE
            1 : QUANTITE
            2 : MONTANT 
            3 : PRIXNET 

        */
        let TYPEREM : number = 0;
        let QTEMONT : number = 0;
        let REM : number = 0;
        let TARIFQTE_ITEMS : RxFTarifQteDocument[] = [];
        switch(_domaine) // _cItem.COMPTET.CT_TYPE
        {
            case 1 : 
                let _spec_FOURNISS = _cItem.ARTFOURNISS_ITEMS.find(m=> m.CT_NUM == _cItem.COMPTET.CT_NUM);
                if(_spec_FOURNISS) { 
                    TYPEREM = _spec_FOURNISS.AF_TYPEREM!;
                    QTEMONT = _spec_FOURNISS.AF_QTEMONT!;
                    REM = _spec_FOURNISS.AF_REMISE!;
                    TARIFQTE_ITEMS = _cItem.TARIFQTE_ITEMS.filter(w => w.TQ_REFCF == _cItem.COMPTET.CT_NUM);
                }
                break;
            case 0 :
            default : 
                let _spec_CLIENT = _cItem.ARTCLIENT_ITEMS.find(m=> m.AC_CATEGORIE == 0 && m.CT_NUM == _cItem.COMPTET.CT_NUM);
                if(_spec_CLIENT) { 
                    TYPEREM = _spec_CLIENT.AC_TYPEREM!;
                    QTEMONT = _spec_CLIENT.AC_QTEMONT!;
                    REM = _spec_CLIENT.AC_REMISE!;
                    TARIFQTE_ITEMS = _cItem.TARIFQTE_ITEMS.filter(w => w.TQ_REFCF == _cItem.COMPTET.CT_NUM);
                }
                else {
                    // RECHERCHE SPEC TARIF : CATEGORIE TARIFAIRE CLIENT
                    let _spec_CATTARIF = _cItem.ARTCLIENT_ITEMS.find(m=> m.AC_CATEGORIE == _cItem.COMPTET.N_CATTARIF);
                    if(_spec_CATTARIF){
                        TYPEREM = _spec_CATTARIF.AC_TYPEREM!;
                        QTEMONT = _spec_CATTARIF.AC_QTEMONT!;
                        REM = _spec_CATTARIF.AC_REMISE!;
                        TARIFQTE_ITEMS = _cItem.TARIFQTE_ITEMS.filter(w => w.TQ_REFCF == 'a' + ('00' + _cItem.COMPTET.N_CATTARIF).slice(-2));
                    }
                }
                break;
        }
        DEFAULT_REMISES_PARAMS.SPECREM_ARTICLE_FOUND = (TYPEREM == 0 && QTEMONT == 0 && REM != 0 ) || // SIMPLE
                                                       (TYPEREM == 1 && QTEMONT == 0) || // HORS_REMISE
                                                       [1,2,3].indexOf(QTEMONT) > -1 && TARIFQTE_ITEMS.length > 0; // QUANTITE | MONTANT
        DEFAULT_REMISES_PARAMS.TYPEREM = TYPEREM;
        DEFAULT_REMISES_PARAMS.QTEMONT = QTEMONT;
        DEFAULT_REMISES_PARAMS.REM = REM;
        DEFAULT_REMISES_PARAMS.TARIFQTE_ITEMS = TARIFQTE_ITEMS;

        if(_cItem.COMPTET.CT_TAUX01 && _cItem.COMPTET.CT_TAUX01 > 0) {
            DEFAULT_REMISES_PARAMS.REM_COMPTET = _cItem.COMPTET.CT_TAUX01!;
            DEFAULT_REMISES_PARAMS.SPECREM_COMPTET_FOUND = true;
        }
        DEFAULT_REMISES_PARAMS.SPECREM_FOUND = DEFAULT_REMISES_PARAMS.SPECREM_ARTICLE_FOUND || DEFAULT_REMISES_PARAMS.SPECREM_COMPTET_FOUND;
        return DEFAULT_REMISES_PARAMS;
    }

    APPLY_DEFAULT_REMISES(M : RxCluDocLigneDocumentType, _cluRemisesResult  : CluDefaultRemisesResult){
        if(!_cluRemisesResult || !_cluRemisesResult.SPECREM_FOUND) return;
        if(_cluRemisesResult.SPECREM_COMPTET_FOUND && !_cluRemisesResult.SPECREM_ARTICLE_FOUND) {
            M.DL_REMISE01REM_TYPE = 0; M.DL_REMISE01REM_VALEUR = 0; M.DL_REMISE02REM_TYPE = 0; M.DL_REMISE02REM_VALEUR = 0; M.DL_REMISE03REM_TYPE = 0; M.DL_REMISE03REM_VALEUR = 0; 
            M.DL_REMISE01REM_TYPE = 1; M.DL_REMISE01REM_VALEUR = _cluRemisesResult.REM_COMPTET;
            this.DL_RECALCUL_TOTAUX_LIGNES(M); 
        }
        else if (!_cluRemisesResult.SPECREM_COMPTET_FOUND && _cluRemisesResult.SPECREM_ARTICLE_FOUND) {
            /*
                TYPEREM : 
                0 : SIMPLE
                1 : HORS_REMISE
    
                QTEMONT :
                0 : SIMPLE & HORS_REMISE
                1 : QUANTITE
                2 : MONTANT 
                3 : PRIXNET
            */
            M.DL_REMISE01REM_TYPE = 0; M.DL_REMISE01REM_VALEUR = 0; M.DL_REMISE02REM_TYPE = 0; M.DL_REMISE02REM_VALEUR = 0; M.DL_REMISE03REM_TYPE = 0; M.DL_REMISE03REM_VALEUR = 0; 
            switch(_cluRemisesResult.QTEMONT){
                case 0 : 
                    switch(_cluRemisesResult.TYPEREM){
                        case 0 : M.DL_REMISE01REM_TYPE = 1; M.DL_REMISE01REM_VALEUR = _cluRemisesResult.REM; break;
                        case 1 : break;
                    }
                    break;
                case 1 : 
                    let TARIFQTE_QT_ITEM_M = _cluRemisesResult.TARIFQTE_ITEMS.find(m=> M.DL_QTE > m.TQ_BORNEINF && M.DL_QTE <= m.TQ_BORNESUP);
                    if(TARIFQTE_QT_ITEM_M) { 
                        M.DL_REMISE01REM_TYPE = TARIFQTE_QT_ITEM_M.TQ_REMISE01REM_TYPE; M.DL_REMISE01REM_VALEUR = TARIFQTE_QT_ITEM_M.TQ_REMISE01REM_VALEUR; 
                        M.DL_REMISE02REM_TYPE = TARIFQTE_QT_ITEM_M.TQ_REMISE02REM_TYPE; M.DL_REMISE02REM_VALEUR = TARIFQTE_QT_ITEM_M.TQ_REMISE02REM_VALEUR; 
                        M.DL_REMISE03REM_TYPE = TARIFQTE_QT_ITEM_M.TQ_REMISE03REM_TYPE; M.DL_REMISE03REM_VALEUR = TARIFQTE_QT_ITEM_M.TQ_REMISE03REM_VALEUR;   
                    }
                    break;
                case 2 : 
                    let TARIFQTE_MT_ITEM_M = _cluRemisesResult.TARIFQTE_ITEMS.find(m=> M.DL_QTE * M.DL_PRIXUNITAIRE > m.TQ_BORNEINF && M.DL_QTE * M.DL_PRIXUNITAIRE <= m.TQ_BORNESUP);
                    if(TARIFQTE_MT_ITEM_M) { 
                        M.DL_REMISE01REM_TYPE = TARIFQTE_MT_ITEM_M.TQ_REMISE01REM_TYPE; M.DL_REMISE01REM_VALEUR = TARIFQTE_MT_ITEM_M.TQ_REMISE01REM_VALEUR; 
                        M.DL_REMISE02REM_TYPE = TARIFQTE_MT_ITEM_M.TQ_REMISE02REM_TYPE; M.DL_REMISE02REM_VALEUR = TARIFQTE_MT_ITEM_M.TQ_REMISE02REM_VALEUR; 
                        M.DL_REMISE03REM_TYPE = TARIFQTE_MT_ITEM_M.TQ_REMISE03REM_TYPE; M.DL_REMISE03REM_VALEUR = TARIFQTE_MT_ITEM_M.TQ_REMISE03REM_VALEUR;   
                    }
                    break;
                case 3 : 
                    let TARIFQTE_PN_ITEM_M = _cluRemisesResult.TARIFQTE_ITEMS.find(m=> M.DL_QTE > m.TQ_BORNEINF && M.DL_QTE <= m.TQ_BORNESUP);
                    if(TARIFQTE_PN_ITEM_M) { 
                        switch(M.DL_TTC){
                            case 0:
                                M.DL_PRIXUNITAIRE = TARIFQTE_PN_ITEM_M.TQ_PRIXNET!;
                                this.DL_RECALCUL_TOTAUX_LIGNES(M);
                                M.DL_PUTTC = M.DL_MONTANTTTC / M.DL_QTE;
                                break;
                            case 1: 
                                M.DL_PUTTC = TARIFQTE_PN_ITEM_M.TQ_PRIXNET!;
                                this.DL_RECALCUL_TOTAUX_LIGNES(M);
                                M.DL_PRIXUNITAIRE = M.DL_MONTANTHT / M.DL_QTE;
                                break;
                        } 
                    }
                    break;
            }
            this.DL_RECALCUL_TOTAUX_LIGNES(M); 
        }
        else {
            /*
                REM_CONFLICT_MODE : 
                0 : PRIORITE COMPTET
                1 : PRIORITE ARTICLE 
                2 : CUMUL
                3 : CASCADE
                4 : AUCUN 
            */
            switch(_cluRemisesResult.REM_CONFLICT_MODE){
                // PRIORITE COMPTET
                case 0 : 
                    let _cluRemisesResult_PRIO_COMPTET  : CluDefaultRemisesResult = JSON.parse(JSON.stringify(_cluRemisesResult)); _cluRemisesResult_PRIO_COMPTET.SPECREM_ARTICLE_FOUND = false;
                    this.APPLY_DEFAULT_REMISES(M, _cluRemisesResult_PRIO_COMPTET); 
                    break;
                // PRIORITE ARTICLE :
                case 1 : 
                    let _cluRemisesResult_PRIO_ARTICLE  : CluDefaultRemisesResult = JSON.parse(JSON.stringify(_cluRemisesResult)); _cluRemisesResult_PRIO_ARTICLE.SPECREM_COMPTET_FOUND = false;
                    this.APPLY_DEFAULT_REMISES(M, _cluRemisesResult_PRIO_ARTICLE); 
                    break;
                // CUMUL
                case 2 : 
                    let _cluRemisesResult_STEP1_CUMUL_ARTICLE  : CluDefaultRemisesResult = JSON.parse(JSON.stringify(_cluRemisesResult)); _cluRemisesResult_STEP1_CUMUL_ARTICLE.SPECREM_COMPTET_FOUND = false;
                    this.APPLY_DEFAULT_REMISES(M, _cluRemisesResult_STEP1_CUMUL_ARTICLE);
                    M.DL_REMISE01REM_TYPE = 1;
                    if(!M.DL_REMISE01REM_VALEUR) M.DL_REMISE01REM_VALEUR = 0;
                    M.DL_REMISE01REM_VALEUR += _cluRemisesResult.REM_COMPTET;
                    this.DL_RECALCUL_TOTAUX_LIGNES(M); 
                    break;
                // CASCADE
                case 3 : 
                    let _cluRemisesResult_STEP1_CASCADE_ARTICLE  : CluDefaultRemisesResult = JSON.parse(JSON.stringify(_cluRemisesResult)); _cluRemisesResult_STEP1_CASCADE_ARTICLE.SPECREM_COMPTET_FOUND = false;
                    this.APPLY_DEFAULT_REMISES(M, _cluRemisesResult_STEP1_CASCADE_ARTICLE);
                    if(M.DL_REMISE01REM_VALEUR! != 0) { M.DL_REMISE02REM_TYPE = 1; M.DL_REMISE02REM_VALEUR = _cluRemisesResult.REM_COMPTET; }
                    else { M.DL_REMISE01REM_TYPE = 1; M.DL_REMISE01REM_VALEUR = _cluRemisesResult.REM_COMPTET; }
                    this.DL_RECALCUL_TOTAUX_LIGNES(M); 
                    break;
                // AUCUNE REMISE
                case 4 :
                    M.DL_REMISE01REM_TYPE = 0; M.DL_REMISE01REM_VALEUR = 0; M.DL_REMISE02REM_TYPE = 0; M.DL_REMISE02REM_VALEUR = 0; M.DL_REMISE03REM_TYPE = 0; M.DL_REMISE03REM_VALEUR = 0; 
                    this.DL_RECALCUL_TOTAUX_LIGNES(M); 
                    break;
            }
        }
    }
    
    APPLY_PROMO_REMISES(M : RxCluDocLigneDocumentType, _cItem : CluDocContextItem) {
        if (M.DL_VALORISE != 1) return;
        if (!_cItem.TARIF_ITEMS || _cItem.TARIF_ITEMS.length == 0) return;
        const TODAY = moment().startOf('day');
        _cItem.TARIF_ITEMS.forEach(_tarifItem => {
            if(_tarifItem.TF_REMISE01REM_VALEUR == 0) return;
            // #region VERIFIER PERIODE
            switch(_tarifItem.TF_TYPEP) {
                case 0 : // LE
                    const TF_DATE_PROMOTION = moment(_tarifItem.TF_DEBUT!).startOf('day');
                    if(!TODAY.isSame(TF_DATE_PROMOTION, 'day')) return;
                    break;
                case 1 : // PENDANT
                    const TF_DEBUT = moment(_tarifItem.TF_DEBUT!).startOf('day');
                    const TF_FIN = moment(_tarifItem.TF_FIN!).startOf('day');
                    if(!TODAY.isBetween(TF_DEBUT, TF_FIN, 'day', '[]')) return;
                    break;
                case 2 : // PERMANENCE
                    break;
                case 3 : // A_PARTIR_DE
                    const TF_DATE_PROMOTION_DEBUT = moment(_tarifItem.TF_DEBUT!).startOf('day');
                    if(!TODAY.isSameOrAfter(TF_DATE_PROMOTION_DEBUT, 'day')) return;
                    break;
                case 4 : // JUSQUAU
                    const TF_DATE_PROMOTION_FIN = moment(_tarifItem.TF_FIN!).startOf('day');
                    if(!TODAY.isSameOrBefore(TF_DATE_PROMOTION_FIN, 'day')) return;
                    break;
            }
            // #endregion 
            let IS_ELLIGIBLE : boolean = true;
            // #region VERIFIER ELLIGIBILITE 
            const TARIFSELECT_ITEMS = !_cItem.TARIFSELECT_ITEMS ? [] : _cItem.TARIFSELECT_ITEMS.filter(m => m.TF_NO == _tarifItem.TF_NO);
            const TARIFSELECT_ITEMS_FAMILLE = TARIFSELECT_ITEMS.filter(m => m.TS_INTERES == 0);
            const TARIFSELECT_ITEMS_ARTICLE = TARIFSELECT_ITEMS.filter(m => m.TS_INTERES == 1);
            const TARIFSELECT_ITEMS_CATEGORIE = TARIFSELECT_ITEMS.filter(m => m.TS_INTERES == 2);
            const TARIFSELECT_ITEMS_COMPTET = TARIFSELECT_ITEMS.filter(m => m.TS_INTERES == 3);
            if (IS_ELLIGIBLE && TARIFSELECT_ITEMS_FAMILLE.length > 0) {
                IS_ELLIGIBLE = TARIFSELECT_ITEMS_FAMILLE.find(m => m.TS_REF == _cItem.ARTICLE.FA_FAMNV1) != undefined;
            }
            if (IS_ELLIGIBLE && TARIFSELECT_ITEMS_ARTICLE.length > 0) {
                IS_ELLIGIBLE = TARIFSELECT_ITEMS_ARTICLE.find(m => m.TS_REF == _cItem.ARTICLE.AR_REF) != undefined;
            }
            if (IS_ELLIGIBLE && TARIFSELECT_ITEMS_CATEGORIE.length > 0) {
                IS_ELLIGIBLE = TARIFSELECT_ITEMS_CATEGORIE.find(m => parseInt(m.TS_REF!) == _cItem.COMPTET.N_CATTARIF) != undefined;
            }
            if (IS_ELLIGIBLE && TARIFSELECT_ITEMS_COMPTET.length > 0) {
                IS_ELLIGIBLE = TARIFSELECT_ITEMS_COMPTET.find(m => m.TS_REF == _cItem.COMPTET.CT_NUM) != undefined;
            }
            // #endregion 
            if (IS_ELLIGIBLE) {
                // #region APPLIQUER_REMISES
                M.DL_REMISE01REM_TYPE = _tarifItem.TF_REMISE01REM_TYPE!; M.DL_REMISE01REM_VALEUR = _tarifItem.TF_REMISE01REM_VALEUR!; 
                M.DL_REMISE02REM_TYPE = _tarifItem.TF_REMISE02REM_TYPE!; M.DL_REMISE02REM_VALEUR = _tarifItem.TF_REMISE02REM_VALEUR!; 
                M.DL_REMISE03REM_TYPE = _tarifItem.TF_REMISE03REM_TYPE!; M.DL_REMISE03REM_VALEUR = _tarifItem.TF_REMISE03REM_VALEUR!;  
                // #endregion 
                this.DL_RECALCUL_TOTAUX_LIGNES(M);
            }
        });
    }

    APPLY_NOMENCLATURE_PREPARTITION_REMISES(M : RxCluDocLigneDocumentType, _nItem : CluNomenclatureItem | undefined) {
        if(!(_nItem && _nItem.NOMENCLATURE && _nItem.NOMENCLATURE.NO_REPARTITION && _nItem.NOMENCLATURE.NO_REPARTITION > 0 && _nItem.PARENT_ARTICLE)) return;
        // #region NOMENCLATURE AVEC % REPARTITION
        let _parentDocLignes = this.LIGNES .filter(m => m.AR_REF === _nItem.PARENT_ARTICLE.AR_REF && m.AR_REFCOMPOSE === _nItem.PARENT_ARTICLE.AR_REF) .sort((a, b) => b.DL_LIGNE - a.DL_LIGNE);
        let _matchDocLigneParent = _parentDocLignes.length > 0 ? _parentDocLignes[0] : undefined;
        switch(_nItem.PARENT_ARTICLE.AR_NOMENCLLIB) {
            case 'COMMERCIALE / COMPOSANT' : 
                if(_matchDocLigneParent) {
                    let VALEUR_REMISE = M.DL_PUTTC! * M.DL_QTE - _matchDocLigneParent.DL_MONTANTTTC * _nItem.NOMENCLATURE.NO_REPARTITION! / 100;
                    let VALEUR_REMISE_F = this.doRoundToActiveFormat(VALEUR_REMISE);
                    // #region APPLIQUER_REMISES
                    M.DL_REMISE01REM_TYPE = 0; M.DL_REMISE01REM_VALEUR = VALEUR_REMISE_F!; 
                    M.DL_REMISE02REM_TYPE = 1; M.DL_REMISE02REM_VALEUR = 0; 
                    M.DL_REMISE03REM_TYPE = 1; M.DL_REMISE03REM_VALEUR = 0;  
                    // #endregion 
                    this.DL_RECALCUL_TOTAUX_LIGNES(M);
                }
                break;
            case 'COMMERCIALE / COMPOSE' : 
                if(_matchDocLigneParent) {
                    let _m_ARTFAMCOMPTA : CluArtFamComptaItem = new CluArtFamComptaItem(); 
                    _m_ARTFAMCOMPTA.DL_CODETAXE1 = M.DL_CODETAXE1; _m_ARTFAMCOMPTA.DL_TAXE1 = M.DL_TAXE1; _m_ARTFAMCOMPTA.DL_TYPETAXE1 = M.DL_TYPETAXE1; _m_ARTFAMCOMPTA.DL_TYPETAUX1 = M.DL_TYPETAUX1;
                    _m_ARTFAMCOMPTA.DL_CODETAXE2 = M.DL_CODETAXE2; _m_ARTFAMCOMPTA.DL_TAXE2 = M.DL_TAXE2; _m_ARTFAMCOMPTA.DL_TYPETAXE2 = M.DL_TYPETAXE2; _m_ARTFAMCOMPTA.DL_TYPETAUX2 = M.DL_TYPETAUX2;
                    _m_ARTFAMCOMPTA.DL_CODETAXE3 = M.DL_CODETAXE3; _m_ARTFAMCOMPTA.DL_TAXE3 = M.DL_TAXE3; _m_ARTFAMCOMPTA.DL_TYPETAXE3 = M.DL_TYPETAXE3; _m_ARTFAMCOMPTA.DL_TYPETAUX3 = M.DL_TYPETAUX3;
                    
                    if(_matchDocLigneParent.DL_TTC == 0) {
                        let DL_MONTANTHT = _matchDocLigneParent.DL_MONTANTHT * _nItem.NOMENCLATURE.NO_REPARTITION! / 100;
                        let DL_POIDSNET = _matchDocLigneParent.DL_POIDSNET! * _nItem.NOMENCLATURE.NO_REPARTITION! / 100;
                        let DL_MONTANTTTC = this.doConvertHTtoTTC(DL_MONTANTHT, DL_POIDSNET, _m_ARTFAMCOMPTA);
                        M.DL_MONTANTHT = DL_MONTANTHT;
                        M.DL_MONTANTTTC = DL_MONTANTTTC;
                    }
                    else {
                        let DL_MONTANTTTC = _matchDocLigneParent.DL_MONTANTTTC * _nItem.NOMENCLATURE.NO_REPARTITION! / 100;
                        let DL_MONTANTHT = this.doConvertTTCtoHT(DL_MONTANTTTC, _matchDocLigneParent.DL_POIDSNET!, _m_ARTFAMCOMPTA);
                        M.DL_MONTANTHT = DL_MONTANTHT;
                        M.DL_MONTANTTTC = DL_MONTANTTTC;
                    }
                    let VALEUR_REMISE = 0;
                    if(M.DL_TTC == 0) { VALEUR_REMISE = M.DL_PRIXUNITAIRE! * M.DL_QTE - M.DL_MONTANTHT; }
                    else { VALEUR_REMISE = M.DL_PUTTC! * M.DL_QTE - M.DL_MONTANTTTC; }
                    let VALEUR_REMISE_F = this.doRoundToActiveFormat(VALEUR_REMISE);
                    // #region APPLIQUER_REMISES
                    M.DL_REMISE01REM_TYPE = 0; M.DL_REMISE01REM_VALEUR = VALEUR_REMISE_F!; 
                    M.DL_REMISE02REM_TYPE = 1; M.DL_REMISE02REM_VALEUR = 0; 
                    M.DL_REMISE03REM_TYPE = 1; M.DL_REMISE03REM_VALEUR = 0;  
                    // #endregion 
                    this.DL_RECALCUL_TOTAUX_LIGNES(M);
                }
                break;
        }
        // #endregion 
    }
    // #endregion 

    // #region Utils
    private splitList_SOUS_TOTAUX(liste: RxCluDocLigneDocumentType[]): RxCluDocLigneDocumentType[][] {
        return liste.reduce((acc : RxCluDocLigneDocumentType[][], objet: RxCluDocLigneDocumentType) => {
            // Vérifiez si l'objet est un séparateur
            if (objet.EST_SOUSTOTAL) {
                // Ajoutez une nouvelle sous-liste
                acc.push([]);
            } else {
                // Ajoutez l'objet à la dernière sous-liste
                acc[acc.length - 1].push(objet);
            }
            return acc;
        }, [[]]);
    }
    private splitList_SOUS_TOTAUX_INDEX(liste: RxCluDocLigneDocumentType[]): number[] {
        let SOUS_TOTAUX_INDEXES : number[] = [];
        liste.forEach((ITEM, INDEX) => {
            if(ITEM.EST_SOUSTOTAL) { 
                SOUS_TOTAUX_INDEXES.push(INDEX);
            }
        })
        return SOUS_TOTAUX_INDEXES;
    }
    private formatNumber_REMISELIB(_value : number) {
        return Number.isInteger(_value) || _value % 1 === 0 ? _value.toFixed(0) : _value.toString();
    }

    private doRound(num : number, decimalPlaces = 0) {
       var p = Math.pow(10, decimalPlaces);
       var n = (num * p) * (1 + Number.EPSILON);
       return Math.round(n) / p;
    }

    private doRoundToActiveFormat(num : number) : number {
        let _format = sessionStorage.getItem('CAURIS_LINKUP_FORMAT') || '';
        if(!_format) return num;
        let _pipe = new CustomNumberPipe();
        let _nbDecimales = _pipe.recupererNombreDecimales(_format);
        return this.doRound(num, _nbDecimales);
    }
    
    private doGetDomaineFromDocumentTypeUtils_RemDocs(_doType : number) : number {
        let _domaine = 0;
        if (_doType < 9) _domaine = 0; // Vente
        else if(_doType >= 10 && _doType < 20) _domaine = 1; // Achat
        else if (_doType >= 20 && _doType < 30) _domaine = 2; // Stocks
        else if (_doType >= 40 && _doType < 50) _domaine = 4; // Interne
        return _domaine;
    }
    // #endregion

    public static fromBackend(data: any): CluDocItem {
        const instance = new CluDocItem();
        Object.assign(instance, data);  // Copie toutes les propriétés de `data` vers l'instance
        return instance;
    }
}